﻿//dépend de la table parametre_appli dans la base avec une ligne et un champ "json"
window.tempoGetParametrage = 60000
window.paraAppli = null
window.jsonDefautAccesPortail = {
    acces_dates_et_tournee: true,
    acces_dates: true,
    acces_tournee: false,
    list_statut_visible: ["Option", "Confirmée"],
    modif_feuille_route: false,
    feuille_route_affiche_nom: true,
    feuille_route_affiche_rdv: true,
    feuille_route_affiche_uti: true,
    feuille_route_affiche_orga: true,
    feuille_route_affiche_externe: true,
    feuille_route_affiche_interne: true,
    affiche_tache: false,
    modif_tache: false,
    cree_tache: false,
    supp_tache: false,
    affiche_liste_destinataire: false,
    affiche_agenda: false,
    partage_agenda: true,
    affiche_liste_rdv: false,
    affiche_activite: false,
    //email_prevenir_feuille_de_route: true,
    //email_prevenir_agenda: true,
    //email_prevenir_tache:false
}

window.cParaAppli = function (bddRef, xml) {
    var Me = this
    var xml = xml
    this.isLoaded = false

    if (typeof bddRef.utiCourantParaJson.warning == 'undefined') bddRef.utiCourantParaJson.warning = {}
    if (typeof bddRef.utiCourantParaJson.warning.parametrage == 'undefined') bddRef.utiCourantParaJson.warning.parametrage = {}
    if (typeof bddRef.utiCourantParaJson.warning.email == 'undefined') bddRef.utiCourantParaJson.warning.email = {}

    this.mGetXml = function () { return xml }

    var timeOutUpdateJson = null
    this.mLoadData = function (async) {
        if (typeof async == 'undefined') async = true
        window.clearTimeout(timeOutUpdateJson)
        var dataToBeSent = {
            command: "paraappli",
            async: ((typeof xml == 'undefined' || xml == null) ? false : async)
        }
        bddRef.mAjaxCall(dataToBeSent, function (data) {
            if (typeof data.xml == 'undefined' || data.xml == null) { xml = {} }
            else { xml = data.xml }
            for (var prop in xml) { xml[prop] = JSON.parse(xml[prop]) }
            if (typeof funcOk != 'undefined') funcOk()
            if (bddRef.utiCourant != null) {
                timeOutUpdateJson = window.setTimeout(function () {
                    Me.mLoadData()
                }, tempoGetParametrage)
            }
            Me.isLoaded = true
        })
        //}
    }
    if (xml == null) this.mLoadData()

    this.mGetPara = function (key, value, funcEnd) {
        if (typeof value != 'undefined') {
            //on veut écrire une valeur
            bddRef.mAjaxCall({ command: "paraappli", key: key, value: JSON.stringify(value), async: false }, function (data) {
                if (funcEnd) funcEnd()
            })
            xml[key] = JSON.stringify(value)
        } else if (typeof xml[key] == 'undefined') {
            //on veut récupérer une valeur
            xml[key] = JSON.stringify(mGetValueDefautFromKey(key))
            if (funcEnd) funcEnd()
        } else {
            if (funcEnd) funcEnd()
        }
        return JSON.parse(xml[key])
    }

    this.mInitPara = function () {
        if (bddRef.utiCnx != null && bddRef.utiCnx.isAuthentified) {
            bddRef.mAjaxCall({
                command: "getallparaappli"
            }, function (data) {
                if (!data.lstparaappli) data.lstparaappli = []
                Me.mGetLstModuleAndLstKey().forEach(function (item) {
                    if (item.isPara) {
                        if (data.lstparaappli.filter(function (o) { return o.cle == item.key }).length == 0) {
                            Me.mGetPara(item.key, item.defaut)
                        }
                    }
                })
            })
        }

    }

    var lstModule = null
    this.mGetLstModuleAndLstKey = function () {
        if (lstModule == null) {
            lstModule = []
            lstModule.push({
                visible: true,
                key: "general",
                key_parent: null,
                title: "Général",
                libellePlus: "Paramètrage général"
            })
            if (bddRef.objCptCli.objetMetier.hasEmail()) {
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasEmail(),
                    key: "email",
                    key_parent: null,
                    title: "Email",
                    libellePlus: "Paramètrage de vos emails"
                })
            }
            if (bddRef.objCptCli.objetMetier.hasSms()) {
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasSms(),
                    key: "sms",
                    key_parent: null,
                    title: "SMS",
                    libellePlus: "Paramètrage de vos SMS"
                })
            }
            if (parametre.code_appli == "ppmasc" && (bddRef.objCptCli.objetMetier.hasEmail() || bddRef.objCptCli.objetMetier.hasSms())) {
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasSms(),
                    key: "rgpd",
                    key_parent: null,
                    title: "RGPD",
                    libellePlus: "Paramètrage de la gestion de la RGPD"
                })
            }
            if (bddRef.objCptCli.objetMetier.hasDates()) {
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasDates(),
                    key: "dates",
                    key_parent: null,
                    title: "Dates & tournées",
                    libellePlus: "Paramètrage des dates & tournées"
                })
            }
            if (bddRef.objCptCli.objetMetier.hasDocCpt()) {
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasDocCpt(),
                    key: "doccpt",
                    key_parent: null,
                    title: "Document comptable",
                    libellePlus: "Paramètrage des documents comptables (Devis, commandes, factures, tickets)"
                })
            }
            if (bddRef.objCptCli.objetMetier.hasFacture() || bddRef.objCptCli.objetMetier.hasCaisse()) {
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasFacture() || bddRef.objCptCli.objetMetier.hasCaisse(),
                    key: "doccpt_general",
                    key_parent: "doccpt",
                    title: "Général",
                    libellePlus: "Paramètrage concernant l'ensemble des documents comptables"
                })
            }
            if (bddRef.objCptCli.objetMetier.hasDocCpt()) {
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasDocCpt(),
                    key: "doccpt_cb",
                    key_parent: "doccpt",
                    title: "Carte bancaire internet",
                    libellePlus: "Paramètrage de la gestion des CB internet"
                })
            }
            if (bddRef.objCptCli.objetMetier.hasDevis()) {
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasDevis(),
                    key: "doccpt_devis",
                    key_parent: "doccpt",
                    title: "Devis",
                    libellePlus: "Paramètrage de la gestion des devis"
                })
            }
            if (bddRef.objCptCli.objetMetier.hasCommande()) {
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasCommande(),
                    key: "doccpt_commande",
                    key_parent: "doccpt",
                    title: "Commande",
                    libellePlus: "Paramètrage de la gestion des commandes"
                })
            }
            if (bddRef.objCptCli.objetMetier.hasFacture()) {
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasFacture(),
                    key: "doccpt_facture",
                    key_parent: "doccpt",
                    title: "Facture",
                    libellePlus: "Paramètrage de la gestion des factures"
                })
            }
            if (bddRef.objCptCli.objetMetier.hasCaisse()) {
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasTicket(),
                    key: "doccpt_ticket",
                    key_parent: "doccpt",
                    title: "Ticket",
                    libellePlus: "Paramètrage de la gestion des tickets (caisse enregistreuse)"
                })
            }

            if (bddRef.objCptCli.objetMetier.hasHebergement()) {
                lstModule.push({
                    visible: true,
                    key: "hebergement_gestion_general",
                    key_parent: "hebergement",
                    title: "Paramètre Générale",
                    libellePlus: "Paramètre de gestion pour les hébergements"
                })
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasHebergement(),
                    key: "hebergement",
                    key_parent: null,
                    title: "Parametrage hébergement",
                    libellePlus: "Paramètrage des hébergements"
                })
                lstModule.push({
                    visible: bddRef.objCptCli.objetMetier.hasHebergementReservationInternet(),
                    key: "hebergement_gestion_reservation",
                    key_parent: "hebergement",
                    title: "Paramètre pour les réservations",
                    libellePlus: "Paramètre de gestion pour vos réservations"
                })
                if (bddRef.objCptCli.objetMetier.hasHebergementReservationInternet()) {
                    lstModule.push({
                        visible: bddRef.objCptCli.objetMetier.hasHebergementReservationInternet(),
                        key: "hebergement_resa_internet",
                        key_parent: "hebergement",
                        title: "Réservation internet",
                        libellePlus: "Paramètre des réservation par internet"
                    })
                    lstModule.push({
                        visible: bddRef.objCptCli.objetMetier.hasHebergementReservationInternet(),
                        key: "hebergement_arrhes",
                        key_parent: "hebergement",
                        title: "Gestion des arrhes",
                        libellePlus: "Paramètre pour la gestion des arrhes"
                    })
                }
            }
        }
        return lstModule.concat(this.mGetLstKey())
    }

    this.mGetLstKey = function () {
        var lst = []
        this.mGetLstCleModuleDefaut().forEach(function (item) {
            item.value = Me.mGetPara(item.key)
            lst.push(item)
        })
        return lst
    }

    var lstCleModuleDefaut = null
    this.mGetLstCleModuleDefaut = function () {
        if (lstCleModuleDefaut == null) {
            lstCleModuleDefaut = []

            //parametre généraux
            if (typeof bddRef.utiCourantParaJson.parametre_general == 'undefined') bddRef.utiCourantParaJson.parametre_general = {}
            if (typeof bddRef.utiCourantParaJson.parametre_general.son_on == 'undefined') bddRef.utiCourantParaJson.parametre_general.son_on = true
            if (typeof bddRef.utiCourantParaJson.parametre_general.popup_email_recu_on == 'undefined') bddRef.utiCourantParaJson.parametre_general.popup_email_recu_on = true
            if (typeof bddRef.utiCourantParaJson.parametre_general.popup_sms_recu_on == 'undefined') bddRef.utiCourantParaJson.parametre_general.popup_sms_recu_on = true
            if (typeof bddRef.utiCourantParaJson.parametre_general.popup_tracking_email_vue_on == 'undefined') bddRef.utiCourantParaJson.parametre_general.popup_tracking_email_vue_on = false
            if (typeof bddRef.utiCourantParaJson.parametre_general.popup_tracking_email_click_on == 'undefined') bddRef.utiCourantParaJson.parametre_general.popup_tracking_email_click_on = true
            if (typeof bddRef.utiCourantParaJson.parametre_general.popup_tracking_sms_vue_on == 'undefined') bddRef.utiCourantParaJson.parametre_general.popup_tracking_sms_vue_on = false
            if (typeof bddRef.utiCourantParaJson.parametre_general.popup_tracking_sms_click_on == 'undefined') bddRef.utiCourantParaJson.parametre_general.popup_tracking_sms_click_on = true
            if (typeof bddRef.utiCourantParaJson.parametre_general.open_for_rappel_automatique == 'undefined') bddRef.utiCourantParaJson.parametre_general.open_for_rappel_automatique = false
            if (typeof bddRef.utiCourantParaJson.parametre_general.animation_grille == 'undefined') bddRef.utiCourantParaJson.parametre_general.animation_grille = false
            if (typeof bddRef.utiCourantParaJson.parametre_general.pagination_grille == 'undefined') bddRef.utiCourantParaJson.parametre_general.pagination_grille = false
            if (typeof bddRef.utiCourantParaJson.parametre_general.fiche_contact_simplifie == 'undefined') bddRef.utiCourantParaJson.parametre_general.fiche_contact_simplifie = false
            lstCleModuleDefaut.push({
                key: "son_on",
                key_parent: "general",
                title: "Son",
                aide: "Activer/Désactiver les sons de l'application.",
                defaut: true,
                type: "boolean",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        value: bddRef.utiCourantParaJson.parametre_general.son_on,
                        onValueChanged: function (e) {
                            bddRef.utiCourantParaJson.parametre_general.son_on = e.value
                            bddRef.mSaveParaJsonUtilisateur();
                        }
                    })
                }
            })
            if (bddRef.objCptCli.objetMetier.hasAgenda()) {
                lstCleModuleDefaut.push({
                    key: "rappel_show",
                    key_parent: "general",
                    title: "Rappel",
                    aide: "Ouvrir automatiquement la liste des rappels si des rappels sont en attente.",
                    defaut: true,
                    type: "boolean",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                            value: bddRef.utiCourantParaJson.parametre_general.open_for_rappel_automatique,
                            onValueChanged: function (e) {
                                bddRef.utiCourantParaJson.parametre_general.open_for_rappel_automatique = e.value
                                bddRef.mSaveParaJsonUtilisateur();
                            }
                        })
                    }
                })
            }
            if (bddRef.objCptCli.objetMetier.hasPlaniti()) {
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "partage_agenda_planiti",
                    key_parent: "general",
                    title: "Planiti",
                    aide: "Partager l'agenda planiti (partager l'agenda qui contient tous les rendez-vous hors réunion planiti qui sont rajouté dans l'agenda planiti).",
                    defaut: false,
                    type: "boolean",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                            value: Me.mGetPara(itemData.key),
                            onValueChanged: function (e) {
                                Me.mGetPara(itemData.key, e.value)
                                if (e.value) { $Table.show() } else { $Table.hide() }
                            }
                        })
                        var urlExt = document.URLRacine + "/" + bddRef.nom_base + "/planitiagendaics"
                        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px;padding:0 5px;border-radius:10px;' class='state-hover' title='copier le lien'><i class='fas fa-copy'></i></td>").appendTo($Tr)
                        $Td.on("click", function (e) {
                            e.stopPropagation()
                            var $temp = $("<input>");
                            $("body").append($temp);
                            $temp.val(urlExt).select();
                            document.execCommand("copy");
                            $temp.remove();
                            mNotify("L'adresse du calendrier a été copiée dans le presse-papier", "success", 6000)
                        })
                        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
                        $("<div style='padding:5px;'><b><u>" + urlExt + "</u></b></div>").appendTo($Td)
                        if (!Me.mGetPara(itemData.key)) $Table.hide()
                    }
                })
            }
            lstCleModuleDefaut.push({
                key: "animation_grille",
                key_parent: "general",
                title: "Animation",
                aide: "Afficher les animations dans les grilles.",
                defaut: true,
                type: "boolean",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        value: bddRef.utiCourantParaJson.parametre_general.animation_grille,
                        onValueChanged: function (e) {
                            bddRef.utiCourantParaJson.parametre_general.animation_grille = e.value
                            bddRef.mSaveParaJsonUtilisateur();
                        }
                    })
                }
            })
            lstCleModuleDefaut.push({
                key: "pagination_grille",
                key_parent: "general",
                title: "Pagination des grilles",
                aide: "Utiliser les grilles en mode pagination.",
                defaut: false,
                type: "boolean",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        value: bddRef.utiCourantParaJson.parametre_general.pagination_grille,
                        onValueChanged: function (e) {
                            bddRef.utiCourantParaJson.parametre_general.pagination_grille = e.value
                            bddRef.mSaveParaJsonUtilisateur();
                            $(window).trigger("changemodepaginationgrille")
                        }
                    })
                }
            })
            lstCleModuleDefaut.push({
                key: "scroll_native",
                key_parent: "general",
                title: "Barre de défilement des grilles",
                aide: "Afficher une barre de défilement large sur les grilles.",
                defaut: false,
                type: "boolean",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        value: bddRef.utiCourantParaJson.parametre_general.scroll_use_native,
                        onValueChanged: function (e) {
                            bddRef.utiCourantParaJson.parametre_general.scroll_use_native = e.value
                            bddRef.mSaveParaJsonUtilisateur();
                            $(window).trigger("changemodepaginationgrille")
                        }
                    })
                }
            })
            //lstCleModuleDefaut.push({
            //    key: "fiche_contact_simplifie",
            //    key_parent: "general",
            //    title: "Fiche contact simplifié",
            //    aide: "Utiliser une fiche plus simple et plus résumé.",
            //    defaut: false,
            //    type: "boolean",
            //    itemTemplate: function (itemData, contentElement) {
            //        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
            //            value: bddRef.utiCourantParaJson.parametre_general.fiche_contact_simplifie,
            //            onValueChanged: function (e) {
            //                bddRef.utiCourantParaJson.parametre_general.fiche_contact_simplifie = e.value
            //                bddRef.mSaveParaJsonUtilisateur();
            //            }
            //        })
            //    }
            //})
            lstCleModuleDefaut.push({
                key: "nb_jour_vidage_corbeille",
                key_parent: "general",
                title: "Nombre de jour vidage corbeille",
                aide: "Préciser le nombre de jours où les éléments que vous avez mis à la corbeille sont gardé avant une destruction définitive.",
                type: "number",
                defaut: 15,
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlNumberBox({
                        buttonLeftRight: true,
                        min: 1,
                        max: 90,
                        value: ((typeof bddRef.utiCourant.nb_jour_vide_corbeille == 'undefined' || bddRef.utiCourant.nb_jour_vide_corbeille == null) ? 15 : bddRef.utiCourant.nb_jour_vide_corbeille),
                        onValueChanged: function (e) {
                            bddRef.utiCourant.nb_jour_vide_corbeille = e.value
                            bddRef.getObjet(bddRef.utiCourant).mSaveChamp("nb_jour_vide_corbeille")
                        }
                    })
                }
            })
            lstCleModuleDefaut.push({
                key: "visu_file_googledoc",
                key_parent: "general",
                title: "Aperçu automatique des fichiers joints",
                aide: "Charger les documents joints (excels, word...) automatiquement.<br/>(L'affichage de l'aperçu de documents joints utilise le service <b>Google docs</b>. Pour afficher les aperçus, vous donnez l'accès aux documents à ce service le temps de l'affichage de l'aperçu. Si vous activez ce paramètre, tous les documents joints que vous voulez afficher seront automatiquement chargé. Dans le cas contraire, il vous sera demandé de confirmer l'affichage pour chaque document).",
                defaut: false,
                type: "boolean",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        value: bddRef.utiCourantParaJson.parametre_general.affichage_previ_doc_automatique,
                        onValueChanged: function (e) {
                            bddRef.utiCourantParaJson.parametre_general.affichage_previ_doc_automatique = e.value
                            bddRef.mSaveParaJsonUtilisateur();
                        }
                    })
                }
            })
            lstCleModuleDefaut.push({
                key: "recalcul_adresse",
                key_parent: "general",
                title: "Recalcul de vos adresses postales",
                aide: "Le recalcul d'adresse postale permet de géocoder l'adresse à partir de la saisie compléte de celle-ci. A partir de cette saisie, " + parametre.nom + " va trouver l'adresse la plus proche et générer l'adresse correspondante complète.<br/>En recalculant vos adresses, vous pouvez ainsi normaliser les départements, régions et pays, particulièrement après une importation.<br/>Le recalcul d'une adresse est équivalent à cliquer dans le champ d'une adresse postale (dans une fiche) et de sélectionner la première occurence qui vous est proposée.<br/>Attention, le recalcul d'adresse peut parfois donner des adresses erronées et cette action est irréversible.",
                defaut: false,
                type: "boolean",
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                        text: "Afficher le résumé des adresses postales",
                        onClick: function (e) {
                            //traitement d'une adresse
                            var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                                fullScreen: false,
                                height: "auto",
                                width: 650,
                                maxHeight: "95%",
                                showMaximize: false,
                                title: "Recalcul adresse postale",
                                contentTemplate: function (contentElement) {
                                    contentElement.css("padding-top", "0")
                                    var jauge = $("<div/>").appendTo(contentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
                                    jauge.mShow()
                                    bddRef.mAjaxCall({
                                        command: "getdetailadressepostalechamptable"
                                    }, function (data) {
                                        if (typeof data.lstadr == 'undefined') data.lstadr = []
                                        if (data.lstadr.length == 0) {
                                            mNotify("Aucune adresse saisie pour ce champ", "warning", 6000)
                                            window.setTimeout(function () { popup.hide() }, 500)
                                        } else {
                                            $("<div style='font-family:barlow condensed;font-size:100%;'>Le recalcul d'adresse postale permet de géocoder l'adresse à partir de la saisie compléte de celle-ci. A partir de cette saisie, " + parametre.nom + " va trouver l'adresse la plus proche et générer l'adresse correspondante complète.</div>").appendTo(contentElement)
                                            $("<div style='padding-top:5px;font-family:barlow condensed;font-size:100%;'>En recalculant vos adresses, vous pouvez ainsi normaliser les départements, régions et pays, particulièrement après une importation.</div>").appendTo(contentElement)
                                            $("<div style='padding-top:5px;font-family:barlow condensed;font-size:100%;'>Le recalcul d'une adresse est équivalent à cliquer dans le champ d'une adresse postale (dans une fiche) et de sélectionner la première occurence qui vous est proposée.</div>").appendTo(contentElement)
                                            $("<div style='padding-top:5px;font-family:barlow condensed;font-size:100%;'>Attention, le recalcul d'adresse peut parfois donner des adresses erronées et cette action est irréversible.</div>").appendTo(contentElement)
                                            $("<div style='font-size:140%;padding-top:10px;'>Vous avez <b style='font-size:160%'>" + data.lstadr.length + "</b> adresses renseignées dont:</div>").appendTo(contentElement)
                                            var $Table = $("<table/>").appendTo(contentElement)
                                            var $Tr = $("<tr/>").appendTo($Table)
                                            var $Td = $("<td style='padding-right:10px;text-align:right;'><b style='font-size:160%'>" + data.lstadr.filter(function (o) { return o.isnormalise == 0 }).length + "</b></td>").appendTo($Tr)
                                            var $Td = $("<td> non normalisées</td>").appendTo($Tr)
                                            var $Tr = $("<tr/>").appendTo($Table)
                                            var $Td = $("<td style='padding-right:10px;text-align:right;'><b style='font-size:160%'>" + data.lstadr.filter(function (o) { return o.hasdpt == 0 }).length + "</b></td>").appendTo($Tr)
                                            var $Td = $("<td> sans département</td>").appendTo($Tr)
                                            var $Tr = $("<tr/>").appendTo($Table)
                                            var $Td = $("<td style='padding-right:10px;text-align:right;'><b style='font-size:160%'>" + data.lstadr.filter(function (o) { return o.hasregion == 0 }).length + "</b></td>").appendTo($Tr)
                                            var $Td = $("<td> sans région</td>").appendTo($Tr)
                                            var $Tr = $("<tr/>").appendTo($Table)
                                            var $Td = $("<td style='padding-right:10px;text-align:right;'><b style='font-size:160%'>" + data.lstadr.filter(function (o) { return o.haspays == 0 }).length + "</b></td>").appendTo($Tr)
                                            var $Td = $("<td> sans pays</td>").appendTo($Tr)
                                            var $Tr = $("<tr/>").appendTo($Table)
                                            var $Td = $("<td style='padding-right:10px;text-align:right;'><b style='font-size:160%'>" + data.lstadr.filter(function (o) { return o.isgeoloc == 0 }).length + "</b></td>").appendTo($Tr)
                                            var $Td = $("<td> sans géolocalisation</td>").appendTo($Tr)

                                            $("<div style='padding-left:20px;'></div>").appendTo(contentElement)

                                            $("<div style='font-size:140%;padding-top:20px;'>Quelles adresses voulez vous recalculer ?</div>").appendTo(contentElement)
                                            var dxTraiteTout = $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlCheckBox({
                                                text: "Toutes les adresses",
                                                value: true,
                                                onValueChanged: function (e) {
                                                    if (e.value) { $DivDetailTraite.slideUp(200) }
                                                    else { $DivDetailTraite.slideDown(200) }
                                                    dxBtRecalcul.component().option("text", "Recalculer " + mGetNbRecalcul() + " adresses")
                                                }
                                            }).dxCtrlCheckBox("instance")
                                            var $DivDetailTraite = $("<div style='display:none'/>").appendTo(contentElement)
                                            var dxTraiteNormalise = $("<div style='margin:5px;'/>").appendTo($DivDetailTraite).dxCtrlCheckBox({
                                                text: "Les adresses non normalisé",
                                                value: true,
                                                onValueChanged: function (e) { dxBtRecalcul.component().option("text", "Recalculer " + mGetNbRecalcul() + " adresses") }
                                            }).dxCtrlCheckBox("instance")
                                            var dxTraiteSsDpt = $("<div style='margin:5px;'/>").appendTo($DivDetailTraite).dxCtrlCheckBox({
                                                text: "Les adresses sans département",
                                                value: false,
                                                onValueChanged: function (e) { dxBtRecalcul.component().option("text", "Recalculer " + mGetNbRecalcul() + " adresses") }
                                            }).dxCtrlCheckBox("instance")
                                            var dxTraiteSsRegion = $("<div style='margin:5px;'/>").appendTo($DivDetailTraite).dxCtrlCheckBox({
                                                text: "Les adresses sans région",
                                                value: false,
                                                onValueChanged: function (e) { dxBtRecalcul.component().option("text", "Recalculer " + mGetNbRecalcul() + " adresses") }
                                            }).dxCtrlCheckBox("instance")
                                            var dxTraiteSsPays = $("<div style='margin:5px;'/>").appendTo($DivDetailTraite).dxCtrlCheckBox({
                                                text: "Les adresses sans pays",
                                                value: false,
                                                onValueChanged: function (e) { dxBtRecalcul.component().option("text", "Recalculer " + mGetNbRecalcul() + " adresses") }
                                            }).dxCtrlCheckBox("instance")
                                            var dxTraiteSsGeoloc = $("<div style='margin:5px;'/>").appendTo($DivDetailTraite).dxCtrlCheckBox({
                                                text: "Les adresses sans géolocalisation",
                                                value: false,
                                                onValueChanged: function (e) { dxBtRecalcul.component().option("text", "Recalculer " + mGetNbRecalcul() + " adresses") }
                                            }).dxCtrlCheckBox("instance")

                                            $("<div style='font-size:140%;padding-top:20px;'>Quelles valeurs voulez-vous recalculer ?</div>").appendTo(contentElement)
                                            var dxTraiteCalcul = $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlCheckBox({
                                                text: "Toutes les informations (geolocalisation, adresse, département, region)",
                                                value: true,
                                                onValueChanged: function (e) {
                                                    if (e.value) { $DivDetailCalcul.slideUp(200) }
                                                    else { $DivDetailCalcul.slideDown(200) }
                                                }
                                            }).dxCtrlCheckBox("instance")
                                            var $DivDetailCalcul = $("<div style='display:none'/>").appendTo(contentElement)
                                            var dxCalculAdresse = $("<div style='margin:5px;'/>").appendTo($DivDetailCalcul).dxCtrlCheckBox({
                                                text: "Recalculer ligne d'adresse, code postale, ville",
                                                value: false,
                                                onValueChanged: function (e) { }
                                            }).dxCtrlCheckBox("instance")
                                            var dxCalculDpt = $("<div style='margin:5px;'/>").appendTo($DivDetailCalcul).dxCtrlCheckBox({
                                                text: "Recalculer le département",
                                                value: false,
                                                onValueChanged: function (e) { }
                                            }).dxCtrlCheckBox("instance")
                                            var dxCalculRegion = $("<div style='margin:5px;'/>").appendTo($DivDetailCalcul).dxCtrlCheckBox({
                                                text: "Recalculer la région",
                                                value: false,
                                                onValueChanged: function (e) { }
                                            }).dxCtrlCheckBox("instance")
                                            var dxCalculPays = $("<div style='margin:5px;'/>").appendTo($DivDetailCalcul).dxCtrlCheckBox({
                                                text: "Recalculer le pays",
                                                value: false,
                                                onValueChanged: function (e) { }
                                            }).dxCtrlCheckBox("instance")
                                            var dxCalculGeoLoc = $("<div style='margin:5px;'/>").appendTo($DivDetailCalcul).dxCtrlCheckBox({
                                                text: "Recalculer la géolocalisation",
                                                value: true,
                                                onValueChanged: function (e) { }
                                            }).dxCtrlCheckBox("instance")

                                            var dxBtRecalcul = $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlButton({
                                                text: "Recalculer " + mGetNbRecalcul() + " adresses",
                                                onClick: function (e) {
                                                    if (mGetNbRecalcul() == 0) {
                                                        mNotify("Aucune adresse à recalculer", "warning", 6000)
                                                    } else {
                                                        popup.hide()
                                                        var data = {}
                                                        data.recalcul_tout = ((dxTraiteTout.option("value") ? "1" : "0"))
                                                        data.recalcul_nonnormalise = ((dxTraiteNormalise.option("value") ? "1" : "0"))
                                                        data.recalcul_ssdpt = ((dxTraiteSsDpt.option("value") ? "1" : "0"))
                                                        data.recalcul_ssregion = ((dxTraiteSsRegion.option("value") ? "1" : "0"))
                                                        data.recalcul_sspays = ((dxTraiteSsPays.option("value") ? "1" : "0"))
                                                        data.recalcul_ssgeoloc = ((dxTraiteSsGeoloc.option("value") ? "1" : "0"))

                                                        data.update_tout = ((dxTraiteCalcul.option("value") ? "1" : "0"))
                                                        data.update_adresse = ((dxCalculAdresse.option("value") ? "1" : "0"))
                                                        data.update_dpt = ((dxCalculDpt.option("value") ? "1" : "0"))
                                                        data.update_region = ((dxCalculRegion.option("value") ? "1" : "0"))
                                                        data.update_pays = ((dxCalculPays.option("value") ? "1" : "0"))
                                                        data.update_geoloc = ((dxCalculGeoLoc.option("value") ? "1" : "0"))

                                                        var trait = new cTraitementBloquantSession(bddRef, {
                                                            nom_type_traitement: "recalculadressepostale",
                                                            data: data
                                                        }, {
                                                        })
                                                    }
                                                }
                                            }).dxCtrlButton("instance")

                                            function mGetNbRecalcul() {
                                                if (dxTraiteTout.option("value")) { return data.lstadr.length }
                                                else {
                                                    return data.lstadr.filter(function (o) {
                                                        return (dxTraiteNormalise.option("value") && o.isnormalise == 0) ||
                                                            (dxTraiteSsDpt.option("value") && o.hasdpt == 0) ||
                                                            (dxTraiteSsRegion.option("value") && o.hasregion == 0) ||
                                                            (dxTraiteSsPays.option("value") && o.haspays == 0) ||
                                                            (dxTraiteSsGeoloc.option("value") && o.isgeoloc == 0)
                                                    }).length
                                                }
                                            }
                                        }
                                        jauge.mHide()
                                    })
                                }
                            }).dxCtrlPopupBase("instance")
                            popup.show()
                        }
                    })
                }
            })

            //EMAIL pour envoi message client
            if (bddRef.objCptCli.objetMetier.hasDocCpt()) {
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "email_adresse_suivi_envoi_auto_client",
                    key_parent: "general",
                    title: "Adresse email de réception copie mail client",
                    aide: "Pour tous les traitements automatiques qui communiquent avec vos clients (envoi de facture sur un paiement CB internet...), vous pouvez définir l'adresse email sur laquelle recevoir une copie du mail (CCI) envoyé au client. Si vous laissez ce champ à vide, vous ne serez pas en copie de ces mails.",
                    defaut: "",
                    type: "txtemail",
                    itemTemplate: function (itemData, contentElement) {
                        var dxCtrlTxtEmail = $("<div/>").appendTo(contentElement).dxCtrlTextEmail({
                            labelMode: 'floating',
                            label: "Adresse email de suivi",
                            showClearButton: false,
                            placeholder: "Saisissez l'adresse " + String.fromCharCode(8203) + "de suivi...",
                            value: Me.mGetPara(itemData.key),
                            maxLength: 500,
                            inputAttr: { autocomplete: 'test-autocomplete' },
                            onValueChanged: function (e) {
                                //dxCtrlTxtEmail.component().option("disabled", true)
                                if (e.value == null || e.value.length == 0) {
                                    Me.mGetPara(itemData.key, "") //, function () { dxCtrlTxtEmail.component().option("disabled", false) })
                                } else {
                                    delete bddRef.utiCourantParaJson.warning.parametrage.adresse_email_pour_client_manquante
                                    Me.mGetPara(itemData.key, e.value) //, function () { dxCtrlTxtEmail.component().option("disabled", false) })
                                }
                            }
                        }).dxCtrlTextEmail("instance")
                    }
                })
            }

            //ouverture site web
            lstCleModuleDefaut.push({
                key: "ouverture_site_web_from_template_grille_dans_onglet",
                key_parent: "general",
                title: "Ouverture des sites web sur les grilles dans un nouvel onglet",
                aide: "Dans les grilles, quand vous cliquez sur un site web, ouvrir le site dans une popup dans l'application (OFF) ou dans un nouvel onglet du navigateur (ON).",
                defaut: false,
                type: "boolean",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        value: bddRef.utiCourantParaJson.parametre_general.ouverture_site_web_from_template_grille_dans_onglet,
                        onValueChanged: function (e) {
                            bddRef.utiCourantParaJson.parametre_general.ouverture_site_web_from_template_grille_dans_onglet = e.value
                            bddRef.mSaveParaJsonUtilisateur();
                        }
                    })
                }
            })
            lstCleModuleDefaut.push({
                key: "ouverture_site_web_from_fiche_activite_dans_onglet",
                key_parent: "general",
                title: "Ouverture des sites web des fiches dans un nouvel onglet",
                aide: "Dans les fiches, quand vous cliquez sur l'ouverture d'un site web, ouvrir le site dans une popup dans l'application (OFF) ou dans un nouvel onglet du navigateur (ON).",
                defaut: false,
                type: "boolean",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        value: bddRef.utiCourantParaJson.parametre_general.ouverture_site_web_from_fiche_activite_dans_onglet,
                        onValueChanged: function (e) {
                            bddRef.utiCourantParaJson.parametre_general.ouverture_site_web_from_fiche_activite_dans_onglet = e.value
                            bddRef.mSaveParaJsonUtilisateur();
                        }
                    })
                }
            })
            lstCleModuleDefaut.push({
                key: "nb_mois_garde_email_nettoyage_balayette",
                key_parent: "general",
                title: "Durée de conservation des emails (nettoyage automatique)",
                aide: "Indiquez pendant combien de mois vos emails doivent être conservés. Si la taille maximale de votre environnement est dépassée, vous serez prévenu et " + parametre.nom + " lancera chaque nuit un nettoyage automatique en supprimant jusqu'à 1 000 des emails envoyés et reçus les plus anciens, à condition qu'ils soient également plus anciens que la durée (en mois) de conservation définie. Quand il n'y aura plus d'emails à supprimé, vous devrez augmenter la taille de votre environnement.",
                type: "number",
                defaut: 24,
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlNumberBox({
                        buttonLeftRight: true,
                        min: 1,
                        value: Me.mGetPara(itemData.key),
                        onValueChanged: function (e) {
                            Me.mGetPara(itemData.key, e.value)
                        }
                    })
                }
            })


            lstCleModuleDefaut.push({
                isPara: true,
                key: "mailing_text_lien_vue_browser",
                key_parent: "email",
                title: "Texte du lien d'affichage d'un mail dans le navigateur",
                aide: "Quand vous intégrez le champ permettant à un destinataire d'afficher votre email dans un navigateur, le texte du lien par défaut est écrit. Vous pouvez ici définir le texte qui sera affiché.",
                defaut: "Voir dans navigateur",
                type: "txtemail",
                itemTemplate: function (itemData, contentElement) {
                    var ds = []
                    bddRef.mGetArray("compte_email").forEach(function (data) { ds.push(data.adresse_email) })
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlTextBox({
                        label: "Texte du lien",
                        labelMode: 'floating',
                        placeholder: "Version en ligne",
                        value: Me.mGetPara(itemData.key),
                        onValueChanged: function (e) {
                            //dx.component().option("disabled", true)
                            Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
                        }
                    })
                }
            })
            //lstCleModuleDefaut.push({
            //    isPara: true,
            //    key: "mailing_text_lien_desinscription",
            //    key_parent: "email",
            //    title: "Texte du lien pour une désinscription",
            //    aide: "Quand vous intégrez le champ permettant à un destinataire de se désinscrire, le texte du lien par défaut est écrit. Vous pouvez ici définir le texte qui sera affiché.",
            //    defaut: "Se désinscrire",
            //    type: "txtemail",
            //    itemTemplate: function (itemData, contentElement) {
            //        var ds = []
            //        bddRef.mGetArray("compte_email").forEach(function (data) { ds.push(data.adresse_email) })
            //        var dx = $("<div/>").appendTo(contentElement).dxCtrlTextBox({
            //            label: "Texte du lien",
            //            labelMode: 'floating',
            //            placeholder: "Se désinscrire",
            //            value: Me.mGetPara(itemData.key),
            //            onValueChanged: function (e) {
            //                //dx.component().option("disabled", true)
            //                Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
            //            }
            //        })
            //    }
            //})
            lstCleModuleDefaut.push({
                isPara: true,
                key: "mailing_text_lien_desinscription",
                key_parent: "email",
                title: "Texte du lien pour une désinscription",
                aide: "Quand vous intégrez le champ permettant à un destinataire de se désinscrire, le texte du lien par défaut est écrit. Vous pouvez ici définir le texte qui sera affiché.",
                defaut: "Se désinscrire",
                type: "txtemail",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlTextBox({
                        label: "Texte du lien",
                        labelMode: 'floating',
                        placeholder: "Se désinscrire",
                        value: Me.mGetPara(itemData.key),
                        onValueChanged: function (e) {
                            //dx.component().option("disabled", true)
                            Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
                        }
                    })
                }
            })
            if (parametre.code_appli == "ppmasc") {
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "rgpd_nbre_annee_conservation_donnees",
                    key_parent: "rgpd",
                    title: "Nombre d'année de conservation des données sans interractions",
                    aide: "Le RGPD impose de ne pas conserver indéfiniment les données de vos contacts. Ce délai démarre à la date de création d'un contact, puis repart à chaque interaction du contact (réponse, clic, note).La CNIL recommande 3 ans. Une durée plus longue est possible si vous pouvez la justifier, par exemple par un cycle de vente long dans votre secteur.<br/>A l'épuisement de ce délai," + parametre.nom + " vous informera avec la liste des contacts concernées.",
                    defaut: 3,
                    type: "txtemail",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxSlider({
                            min: 1,
                            max: 5,
                            step: 1,
                            value: Me.mGetPara(itemData.key) || 5,
                            label: {
                                visible: true,
                                position: "top"
                            },
                            tooltip: {
                                enabled: true,
                                showMode: "always",
                                position: "bottom",
                                format: function (value) {
                                    return value + " an(s)";
                                }
                            },
                            onValueChanged: function (e) {
                                Me.mGetPara(itemData.key, (!e.value ? 5 : e.value))
                            }
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "desactiver_gestion_contact_sans_interaction_rgpd",
                    key_parent: "rgpd",
                    title: "Désactiver le contrôle de conservation RGPD",
                    aide: "Dans le cadre du RGPD, les contacts avec lesquels vous n'avez eu aucune interaction depuis plus de X années doivent être supprimés. " + parametre.nom + " vous prévient un mois avant l'échéance et vous laisse décider de l'action à entreprendre. Vous pouvez totalement désactiver ce comportement et gérer par vous même le contrôle de la conservation des contacts sans interaction.",
                    defaut: "0",
                    type: "txtemail",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCheckBox({
                            text: "Désactiver le contrôle de conservation RGPD",
                            value: (Me.mGetPara(itemData.key) == "1"),
                            onValueChanged: function (e) {
                                //dx.component().option("disabled", true)
                                Me.mGetPara(itemData.key, (e.value ? "1" : "0")) //, function () { dx.component().option("disabled", false) })
                            }
                        })
                    }
                })
                if (bddRef.objCptCli.objetMetier.hasEmail()) {
                    lstCleModuleDefaut.push({
                        isPara: true,
                        key: "rgpd_modele_email_relance_pour_contact_sans_interaction",
                        key_parent: "rgpd",
                        title: "Modèle email pour relance contact sans interaction",
                        aide: "Quand des contacts dépasse le délais d'existence sans interaction, vous pouvez les relancer par email pour les informer que leur données vont-être supprimées et qu'ils peuvent empêcher cela en cliquant sur un lien fourni dans l'email.",
                        defaut: 'lVRbb+pGEH4uEv9hxEN5KOZ+iwGnhDhRKh2SBtqqT9Zij2Fbe9fZi88hv76zJjnQi6ocZIn1+ptvvv1mZvNws1nehx6/9WHenUxHo/FkMhwOxv1hMp4kvf6432WjJMHBVZr8WMhCy9QE9Vqy3IY+/IZJC3pDeIwN9Lv9MfQm/qjnD7rwQ7ff7dZr+pebn8LV1ofFNdfSm05HV17v+ufrjbQHxg2+eqW0OoqlMFxYVNEi7EYKYywlV5GQOuIilSpnhkuho8Xg7npRr+UPn0KvDJ83D49rH3ptShQ/rrfheuuZ359IV24zwwumTIdlBpWg8BJn9dp3O2lFwtRx0fCqX7SI1vjFPBE06nZ70XIwuFsuV9P29KZ3FfaHq0a9Vq9tD1wDPexMDJ9IA+SoNdtj24E874OU/xRrCN05mDxzAuMDUxrNonG2q3ER8Lxcb+7CZw/Xq8fbh/W9Dy9WGky8QnFh2C5DJ2Xu2IL5AVkSzHM0DATLcTG4bZYcPxdSmSY4y1EYt/mZJ+aAJY/Rq5Yt4IIbzjJPx+Q2y1woudwM5p0T504mR9DmWH1ppETlpSzn2dEHpiiwBQfMSjQ8Zi3QTGhPo+LpjNgqsOav6PeGxZdZI5gnvAxupPhDWtWad9xbtTXfKUiYYV5OunZyb7XL1aOAdwyxlcGv1D+Q8r1V+Ep4oUFIo5C24gNHosDqqCw2mtaFpTJaATEqw7gg7/NCVwqB2F4sUjTxsSN1G6CFpLkIr6gmYo+g3JIsa39EJLFdwFay6mIiyIkAmIXn+6fb1imZqBSSQaVLWjBqNZEQNKUqVHBymSYJEikEbaM7B+FQadqg1YvljoPeDBSZdeGGcIp68wSnfqVMbv80SsTmpqkNG3ducobenE9lZZzr7hatNamS6pyUBLoM2hbUa3m1VzlRVeHdjODi0BsObrhJ2Nusw9cxBxpzeB/zShupsCzjThtRk/cGZJrSGagZszcem6bcVAXN+ItjiblHVmj30f97Ud50uCrQ/7lV3ax5lGcvfHC1RDVrnAv4v7Bg7mYBDgpTBzkYU2i/02FF0c6Zjhm500bb+XrGBhim9ugmrBHtMib+bASXQe4e+6+4eYcF34udLmbfMgyups5yIUXrZJdospI8VxxFZXfKOFXXryr7r6pimrL4tMOskZU240zOP9rwF5gblzKm3qGbwBEQm3n73HE3h7tG3AX1DXem59VrfwE=',
                        itemTemplate: function (itemData, contentElement) {
                            $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                                bddCtrl: bddRef,
                                value: Me.mGetPara(itemData.key),
                                dataDefault: itemData.defaut,
                                allowSup: false,
                                tooltipModif: "Modifier le modele",
                                tooltipSupp: "Supprimer le modele",
                                tooltipNew: "Créer un nouveau modéle",
                                titlePopupEmail: itemData.title,
                                rempliTxtLib: function (contentElement, value) {
                                    var txtLib = ""
                                    txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                                    contentElement.html(txtLib)
                                },
                                onValueChanged: function (data64Signature) {
                                    debugger
                                    Me.mGetPara(itemData.key, data64Signature)
                                }
                            }).dxCtrlEmailData("instance")
                        }
                    })
                    lstCleModuleDefaut.push({
                        isPara: true,
                        key: "mailing_text_lien_desinscription_rgpd",
                        key_parent: "email",
                        title: "Texte du lien pour une désinscription",
                        aide: "Quand vous intégrez le champ permettant à un destinataire de se désinscrire, le texte du lien par défaut est écrit. Vous pouvez ici définir le texte qui sera affiché.",
                        defaut: "Se désinscrire",
                        type: "txtemail",
                        itemTemplate: function (itemData, contentElement) {
                            var dx = $("<div/>").appendTo(contentElement).dxCtrlTextBox({
                                label: "Texte du lien",
                                labelMode: 'floating',
                                placeholder: "Se désinscrire",
                                value: Me.mGetPara(itemData.key),
                                onValueChanged: function (e) {
                                    if (e.value == null || e.value.length == 0) {
                                        e.component.option("value", "Se désinscrire")
                                        mNotify("Le libellé du lien ne peut pas être vide", "error", 6000)
                                    } else {
                                        Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
                                    }
                                }
                            })
                        }
                    })
                    lstCleModuleDefaut.push({
                        isPara: true,
                        key: "mailing_text_lien_desactive_pixel_suivi",
                        key_parent: "rgpd",
                        title: "Texte du lien pour désactivation du pixel de suivi",
                        aide: "Quand vous intégrez le champ permettant à un destinataire de désactiver le pixel de suivi, le texte du lien par défaut est écrit. Vous pouvez ici définir le texte qui sera affiché.",
                        defaut: "Désactiver pixel suivi",
                        type: "txtemail",
                        itemTemplate: function (itemData, contentElement) {
                            var dx = $("<div/>").appendTo(contentElement).dxCtrlTextBox({
                                label: "Texte du lien",
                                labelMode: 'floating',
                                placeholder: "Désactiver pixel suivi",
                                value: Me.mGetPara(itemData.key),
                                onValueChanged: function (e) {
                                    //dx.component().option("disabled", true)
                                    if (e.value == null || e.value.length == 0) {
                                        e.component.option("value", "Désactiver pixel suivi")
                                        mNotify("Le libellé du lien ne peut pas être vide", "error", 6000)
                                    } else {
                                        Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
                                    }
                                }
                            })
                        }
                    })
                    lstCleModuleDefaut.push({
                        isPara: true,
                        key: "mailing_text_lien_politique_confidentialite",
                        key_parent: "rgpd",
                        title: "Parametre de votre politique de confidentialité",
                        aide: "Information concernant votre politique de confidentialité. Ces informations sont utilisé quand vous intégrez un lien sur votre politique de confidentialité au sein de vos emailing. Vous pourrez les corriger au moment de l'intégration de ce lien.",
                        defaut: "Politique de confidentialité",
                        type: "txtemail",
                        itemTemplate: function (itemData, contentElement) {
                            if (!Me.mGetPara("mailing_text_lien_politique_confidentialite") || Me.mGetPara("mailing_text_lien_politique_confidentialite").length == 0) {
                                Me.mGetPara("mailing_text_lien_politique_confidentialite", "")
                            }
                            var dx = $("<div/>").appendTo(contentElement).dxCtrlTextBox({
                                label: "Texte du lien",
                                labelMode: 'floating',
                                placeholder: "Texte du lien pour afficher la politique de confidentialité",
                                value: Me.mGetPara("mailing_text_lien_politique_confidentialite"),
                                onValueChanged: function (e) {
                                    Me.mGetPara("mailing_text_lien_politique_confidentialite", e.value)
                                }
                            })
                            var dx = $("<div/>").appendTo(contentElement).dxCtrlTextBox({
                                label: "Nom de votre société",
                                labelMode: 'floating',
                                placeholder: "Nom de la société lié à la politique de confidentialité",
                                value: Me.mGetPara("nom_societe_politique_confidentialite"),
                                onValueChanged: function (e) {
                                    Me.mGetPara("nom_societe_politique_confidentialite", e.value)
                                }
                            })
                            var dx = $("<div style='margin-bottom:10px;'/>").appendTo(contentElement).dxCtrlTextBox({
                                label: "Texte du lien",
                                labelMode: 'floating',
                                placeholder: "Adresse email du responsable RGPD",
                                value: Me.mGetPara("adresse_email_politique_confidentialite"),
                                onValueChanged: function (e) {
                                    Me.mGetPara("adresse_email_politique_confidentialite", e.value)
                                }
                            })
                            var $A = $("<a href='javascript:void(0)'>Voir la politique de confidentialité</a>").appendTo(contentElement)
                            $A.on("click", function () {
                                var rgpd = new cRgpd({ bddCtrl: bddRef })
                                rgpd.mShowPolitiqueConfidentialite(Me.mGetPara("nom_societe_politique_confidentialite"), Me.mGetPara("adresse_email_politique_confidentialite"), true)
                            })
                        }
                    })
                }
            }

            lstCleModuleDefaut.push({
                key: "popup_tracking_email_vue_on",
                key_parent: "email",
                title: "Popup nouveau tracking vue email",
                aide: "Activer/Désactiver les popups vous signalant les trackings vues emails.",
                defaut: false,
                type: "boolean",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        value: bddRef.utiCourantParaJson.parametre_general.popup_tracking_email_vue_on,
                        onValueChanged: function (e) {
                            bddRef.utiCourantParaJson.parametre_general.popup_tracking_email_vue_on = e.value
                            bddRef.mSaveParaJsonUtilisateur();
                        }
                    })
                }
            })
            lstCleModuleDefaut.push({
                key: "popup_tracking_email_click_on",
                key_parent: "email",
                title: "Popup nouveau tracking click email",
                aide: "Activer/Désactiver les popups vous signalant les trackings clicks emails.",
                defaut: true,
                type: "boolean",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        //label: "Son application",
                        //labelMode: 'floating',
                        value: bddRef.utiCourantParaJson.parametre_general.popup_tracking_email_click_on,
                        onValueChanged: function (e) {
                            bddRef.utiCourantParaJson.parametre_general.popup_tracking_email_click_on = e.value
                            bddRef.mSaveParaJsonUtilisateur();
                        }
                    })
                }
            })

            if (bddRef.baseAppli.para.email.has_reception_email) {
                if (typeof bddRef.utiCourantParaJson.parametre_general.email_dans_classeur_archivage_auto == 'undefined') bddRef.utiCourantParaJson.parametre_general.email_dans_classeur_archivage_auto = true
                lstCleModuleDefaut.push({
                    key: "gestion_email_dans_classeur_archivage",
                    key_parent: "email",
                    title: "Archiver les emails reçus qui sont glissé/déposer dans un classeur",
                    aide: "Quand un mail reçu est glissé/déposé dans un classeur, celui-ci est automatiquement archivé.",
                    defaut: true,
                    type: "boolean",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                            //label: "Son application",
                            //labelMode: 'floating',
                            value: bddRef.utiCourantParaJson.parametre_general.email_dans_classeur_archivage_auto,
                            onValueChanged: function (e) {
                                bddRef.utiCourantParaJson.parametre_general.email_dans_classeur_archivage_auto = e.value
                                bddRef.mSaveParaJsonUtilisateur();
                            }
                        })
                    }
                })

                if (typeof bddRef.utiCourantParaJson.parametre_general.reponse_email_archive_email_recu == 'undefined') bddRef.utiCourantParaJson.parametre_general.reponse_email_archive_email_recu = true
                lstCleModuleDefaut.push({
                    key: "reponse_email_archive_email_recu",
                    key_parent: "email",
                    title: "Quand vous répondez par mail à un email reçu, classer automatiquement le mail reçu en archive",
                    aide: "Quand vous répondez ou transférez un email présent dans votre boîte de réception, celui-ci est automatiquement déplacé vers les archives dès l’envoi de votre message (il n’apparaît donc plus dans votre boîte de réception).",
                    defaut: true,
                    type: "boolean",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                            //label: "Son application",
                            //labelMode: 'floating',
                            value: bddRef.utiCourantParaJson.parametre_general.reponse_email_archive_email_recu,
                            onValueChanged: function (e) {
                                bddRef.utiCourantParaJson.parametre_general.reponse_email_archive_email_recu = e.value
                                bddRef.utiCourantParaJson.parametre_general.jai_compris_reponse_email_archive_email_recu = false
                                bddRef.mSaveParaJsonUtilisateur();
                            }
                        })
                    }
                })
            }

            lstCleModuleDefaut.push({
                isPara: true,
                key: "smtp_copier_email_envoyer_si_imap",
                key_parent: "email",
                title: "En IMAP, copier les emails envoyés sur le serveur de mon adresse email",
                aide: "Si vous avez configuré la réception de vos emails avec le protocole IMAP, vous pouvez demander à ce que les emails envoyés avec " + parametre.nom + " soient également copiés sur le serveur de votre adresse email. Seuls les emails « classiques » sont concernés: les emails envoyés sans tracking, ou avec tracking mais à un seul destinataire. Les emails de publipostage ou de mailing en masse ne sont donc pas copiés sur votre serveur.",
                defaut: "1",
                type: "txtemail",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        value: (Me.mGetPara(itemData.key) == "1"),
                        onValueChanged: function (e) {
                            Me.mGetPara(itemData.key, (e.value ? "1" : "0"))
                        }
                    })
                }
            })

            ////if (bddRef.objCptCli.objetMetier.hasProjet()) {
            ////    if (typeof bddRef.utiCourantParaJson.parametre_general.email_afficher_selection_projet_dans_fenetre == 'undefined') bddRef.utiCourantParaJson.parametre_general.email_afficher_selection_projet_dans_fenetre = false
            ////    lstCleModuleDefaut.push({
            ////        key: "gestion_projet_dans_fiche_email",
            ////        key_parent: "email",
            ////        title: "Afficher les projets dans les emails",
            ////        aide: "Dans la fenêtre des emails reçus et envoyées, Afficher le contrôle de sélection de projet.",
            ////        defaut: true,
            ////        type: "boolean",
            ////        itemTemplate: function (itemData, contentElement) {
            ////            var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
            ////                //label: "Son application",
            ////                //labelMode: 'floating',
            ////                value: bddRef.utiCourantParaJson.parametre_general.email_afficher_selection_projet_dans_fenetre,
            ////                onValueChanged: function (e) {
            ////                    bddRef.utiCourantParaJson.parametre_general.email_afficher_selection_projet_dans_fenetre = e.value
            ////                    bddRef.mSaveParaJsonUtilisateur();
            ////                }
            ////            })
            ////        }
            ////    })
            ////}

            if (bddRef.baseAppli.para.email.has_reception_email) {
                if (typeof bddRef.utiCourantParaJson.parametre_general.email_afficher_selection_classeur_dans_fenetre == 'undefined') bddRef.utiCourantParaJson.parametre_general.email_afficher_selection_classeur_dans_fenetre = true
                lstCleModuleDefaut.push({
                    key: "gestion_classeur_dans_fiche_email",
                    key_parent: "email",
                    title: "Afficher les classeurs dans les emails",
                    aide: "Dans la fenêtre des emails reçus et envoyées, Afficher le contrôle de sélection de classeurs.",
                    defaut: false,
                    type: "boolean",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                            //label: "Son application",
                            //labelMode: 'floating',
                            value: bddRef.utiCourantParaJson.parametre_general.email_afficher_selection_classeur_dans_fenetre,
                            onValueChanged: function (e) {
                                bddRef.utiCourantParaJson.parametre_general.email_afficher_selection_classeur_dans_fenetre = e.value
                                bddRef.mSaveParaJsonUtilisateur();
                            }
                        })
                    }
                })
            }

            //SMS pour envoi message client
            lstCleModuleDefaut.push({
                isPara: true,
                key: "sms_emetteur",
                key_parent: "sms",
                title: "Emetteur de vos SMS",
                aide: "Nom de l'expéditeur affiché à votre correspondant pour l'envoi de vos SMS. (Entre 4 et 11 caractères, uniquement des lettres et des chiffres, pas uniquement des chiffres). Si vide, l'émetteur affiché sera <b>'" + parametre.nom + "'</b>.",
                defaut: "",
                type: "txt",
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlSaisieEmetteurSms({
                        bddCtrl: bddRef,
                        afficheAide: false,
                        value: Me.mGetPara(itemData.key),
                        onValueChanged: function (e) {
                            Me.mGetPara(itemData.key, e.value.toUpperCase())
                        }
                    })
                }
            })
            lstCleModuleDefaut.push({
                key: "popup_tracking_smsvue_on",
                key_parent: "sms",
                title: "Popup nouveau tracking vue sms",
                aide: "Activer/Désactiver les popups vous signalant les trackings vues sms.",
                defaut: false,
                type: "boolean",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        //label: "Son application",
                        //labelMode: 'floating',
                        value: bddRef.utiCourantParaJson.parametre_general.popup_tracking_sms_vue_on,
                        onValueChanged: function (e) {
                            bddRef.utiCourantParaJson.parametre_general.popup_tracking_sms_vue_on = e.value
                            bddRef.mSaveParaJsonUtilisateur();
                        }
                    })
                }
            })
            lstCleModuleDefaut.push({
                key: "popup_tracking_sms_click_on",
                key_parent: "sms",
                title: "Popup nouveau tracking click sms",
                aide: "Activer/Désactiver les popups vous signalant les trackings clicks sms.",
                defaut: true,
                type: "boolean",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        //label: "Son application",
                        //labelMode: 'floating',
                        value: bddRef.utiCourantParaJson.parametre_general.popup_tracking_sms_click_on,
                        onValueChanged: function (e) {
                            bddRef.utiCourantParaJson.parametre_general.popup_tracking_sms_click_on = e.value
                            bddRef.mSaveParaJsonUtilisateur();
                        }
                    })
                }
            })

            if (bddRef.objCptCli.objetMetier.hasDates()) {
                //Tournée & dates
                if (typeof bddRef.utiCourantParaJson.parametre_general.dates == 'undefined') bddRef.utiCourantParaJson.parametre_general.dates = {}

                if (typeof bddRef.utiCourantParaJson.parametre_general.dates.afficher_tournee_annule_dans_listdrag == 'undefined') bddRef.utiCourantParaJson.parametre_general.dates.afficher_tournee_annule_dans_listdrag = false
                if (typeof bddRef.utiCourantParaJson.parametre_general.dates.afficher_tournee_termine_dans_listdrag == 'undefined') bddRef.utiCourantParaJson.parametre_general.dates.afficher_tournee_termine_dans_listdrag = false
                lstCleModuleDefaut.push({
                    key: "afficher_tournee_annule_dans_listdrag",
                    key_parent: "dates",
                    title: "Afficher les tournées annulées dans l'arborescence",
                    aide: "Afficher/Cacher les tournées annulées dans l'arborescence qui permet de glisser/déposer des documents (email, sms...).",
                    defaut: false,
                    type: "boolean",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                            value: bddRef.utiCourantParaJson.parametre_general.dates.afficher_tournee_annule_dans_listdrag,
                            onValueChanged: function (e) {
                                bddRef.utiCourantParaJson.parametre_general.dates.afficher_tournee_annule_dans_listdrag = e.value
                                bddRef.mSaveParaJsonUtilisateur();
                            }
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    key: "afficher_tournee_termine_dans_listdrag",
                    key_parent: "dates",
                    title: "Afficher les tournées terminées dans l'arborescence",
                    aide: "Afficher/Cacher les tournées terminées dans l'arborescence qui permet de glisser/déposer des documents (email, sms...).",
                    defaut: false,
                    type: "boolean",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                            value: bddRef.utiCourantParaJson.parametre_general.dates.afficher_tournee_termine_dans_listdrag,
                            onValueChanged: function (e) {
                                bddRef.utiCourantParaJson.parametre_general.dates.afficher_tournee_termine_dans_listdrag = e.value
                                bddRef.mSaveParaJsonUtilisateur();
                            }
                        })
                    }
                })

                if (typeof bddRef.utiCourantParaJson.parametre_general.dates.afficher_dates_annule_dans_listdrag == 'undefined') bddRef.utiCourantParaJson.parametre_general.dates.afficher_dates_annule_dans_listdrag = false
                if (typeof bddRef.utiCourantParaJson.parametre_general.dates.afficher_dates_termine_dans_listdrag == 'undefined') bddRef.utiCourantParaJson.parametre_general.dates.afficher_dates_termine_dans_listdrag = false
                lstCleModuleDefaut.push({
                    key: "afficher_dates_annule_dans_listdrag",
                    key_parent: "dates",
                    title: "Afficher les dates annulées dans l'arborescence",
                    aide: "Afficher/Cacher les dates annulées dans l'arborescence qui permet de glisser/déposer des documents (email, sms...).",
                    defaut: false,
                    type: "boolean",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                            value: bddRef.utiCourantParaJson.parametre_general.dates.afficher_dates_annule_dans_listdrag,
                            onValueChanged: function (e) {
                                bddRef.utiCourantParaJson.parametre_general.dates.afficher_dates_annule_dans_listdrag = e.value
                                bddRef.mSaveParaJsonUtilisateur();
                            }
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    key: "afficher_dates_termine_dans_listdrag",
                    key_parent: "dates",
                    title: "Afficher les dates terminées dans l'arborescence",
                    aide: "Afficher/Cacher les dates terminées dans l'arborescence qui permet de glisser/déposer des documents (email, sms...).",
                    defaut: false,
                    type: "boolean",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                            value: bddRef.utiCourantParaJson.parametre_general.dates.afficher_dates_termine_dans_listdrag,
                            onValueChanged: function (e) {
                                bddRef.utiCourantParaJson.parametre_general.dates.afficher_dates_termine_dans_listdrag = e.value
                                bddRef.mSaveParaJsonUtilisateur();
                            }
                        })
                    }
                })

                if (typeof bddRef.utiCourantParaJson.parametre_general.tri_tournee_date == 'undefined') bddRef.utiCourantParaJson.parametre_general.tri_tournee_date = 0
                lstCleModuleDefaut.push({
                    key: "tri_tournee_date",
                    key_parent: "dates",
                    title: "Tri des tournées/dates dans l'arborescence",
                    aide: "Définissez le tri des tournées et dates dans l'arborescence qui se situe à droite dans les emails et communication.",
                    defaut: 0,
                    type: "number",
                    itemTemplate: function (itemData, contentElement) {
                        var ds = ["Alphabétique", "Par date"]
                        var dx = $("<div/>").appendTo(contentElement).dxRadioGroup({
                            items: ds,
                            value: ds[bddRef.utiCourantParaJson.parametre_general.tri_tournee_date],
                            layout: 'horizontal',
                            onValueChanged: function (e) {
                                bddRef.utiCourantParaJson.parametre_general.dates.tri_tournee_date = ds.indexOf(e.value)
                                bddRef.mSaveParaJsonUtilisateur();
                            }
                        });
                    }
                })

                if (typeof bddRef.utiCourantParaJson.parametre_general.email_dans_dates_archivage_auto == 'undefined') bddRef.utiCourantParaJson.parametre_general.email_dans_dates_archivage_auto = true
                lstCleModuleDefaut.push({
                    key: "email_dans_dates_archivage_auto",
                    key_parent: "dates",
                    title: "Archiver les emails reçus qui sont glissé/déposer dans une date",
                    aide: "Quand un mail reçu est glissé/déposé dans une date, celui-ci est automatiquement archivé.",
                    defaut: true,
                    type: "boolean",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                            //label: "Son application",
                            //labelMode: 'floating',
                            value: bddRef.utiCourantParaJson.parametre_general.email_dans_dates_archivage_auto,
                            onValueChanged: function (e) {
                                bddRef.utiCourantParaJson.parametre_general.email_dans_dates_archivage_auto = e.value
                                bddRef.mSaveParaJsonUtilisateur();
                            }
                        })
                    }
                })

                lstCleModuleDefaut.push({
                    key: "envoi_mail_supp_portail_expire",
                    key_parent: "dates",
                    title: "Envoyer un email d'information d'expiration d'un accès au portail",
                    aide: "Vous pouvez définir une date d'expiration à l'accès au portail. A l'arrivé de cette date d'expiration, " + parametre.nom + " supprime automatiquement l'accès au portail. Vous pouvez informer par mail de cette suppression le contact qui utilise cet accès.",
                    defaut: "1",
                    type: "boolean",
                    itemTemplate: function (itemData, contentElement) {
                        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        var dx1 = $("<div/>").appendTo($Td).dxCtrlSwitch({
                            value: (Me.mGetPara(itemData.key + "_contact") == "1" || Me.mGetPara(itemData.key + "_contact") == null),
                            onValueChanged: function (e) {
                                Me.mGetPara(itemData.key + "_contact", ((e.value) ? "1" : "0"))
                            }
                        })
                        var $Td = $("<td style='width:100%;font-family:barlow condensed;'>Prévenir le contact</td>").appendTo($Tr)

                        //var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                        //var $Tr = $("<tr/>").appendTo($Table)
                        //var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        //var dx2 = $("<div/>").appendTo($Td).dxCtrlSwitch({
                        //    value: (Me.mGetPara(itemData.key + "_uti") == "1" || Me.mGetPara(itemData.key + "_uti") == null),
                        //    onValueChanged: function (e) {
                        //        Me.mGetPara(itemData.key + "_uti", ((e.value) ? "1" : "0"))
                        //    }
                        //})
                        //var $Td = $("<td style='width:100%;font-family:barlow condensed;'>Prévenir l'utilisateur de " + parametre.nom + " qui a ouvert l'accès au portail</td>").appendTo($Tr)
                    }
                })

                lstCleModuleDefaut.push({
                    key: "envoi_mail_supp_portail_sans_mail",
                    key_parent: "dates",
                    title: "Envoyer un email d'information de suppression d'un accès au portail",
                    aide: "Toutes les nuits, " + parametre.nom + " vérifie que les emails des accès au portail que vous avez configuré sont toujours présents dans votre base. Si l'email n'existe plus, " + parametre.nom + " supprime l'accès au portail. Vous pouvez informer par mail de cette suppression le contact qui utilie cet l'accès.",
                    defaut: "1",
                    type: "boolean",
                    itemTemplate: function (itemData, contentElement) {
                        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        var dx1 = $("<div/>").appendTo($Td).dxCtrlSwitch({
                            value: (Me.mGetPara(itemData.key + "_contact") == "1" || Me.mGetPara(itemData.key + "_contact") == null),
                            onValueChanged: function (e) {
                                Me.mGetPara(itemData.key + "_contact", ((e.value) ? "1" : "0"))
                            }
                        })
                        var $Td = $("<td style='width:100%;font-family:barlow condensed;'>Prévenir le contact</td>").appendTo($Tr)

                        //var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                        //var $Tr = $("<tr/>").appendTo($Table)
                        //var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        //var dx2 = $("<div/>").appendTo($Td).dxCtrlSwitch({
                        //    value: (Me.mGetPara(itemData.key + "_uti") == "1" || Me.mGetPara(itemData.key + "_uti") == null),
                        //    onValueChanged: function (e) {
                        //        Me.mGetPara(itemData.key + "_uti", ((e.value) ? "1" : "0"))
                        //    }
                        //})
                        //var $Td = $("<td style='width:100%;font-family:barlow condensed;'>Prévenir l'utilisateur de " + parametre.nom + " qui a ouvert l'accès au portail</td>").appendTo($Tr)
                    }
                })

                if (!bddRef.paraAppli.mGetPara("portail_adresse_email_cci_email_technique")) {
                    bddRef.paraAppli.mGetPara("portail_adresse_email_cci_email_technique", bddRef.objCptCli.data.adresse_email)
                }
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "portail_adresse_email_cci_email_technique",
                    key_parent: "dates",
                    title: "Recevoir en copie CCI tous les emails d'information sur les accés au portail",
                    aide: "Quand " + parametre.nom + " envoi un email d'information sur l'accés au portail à une fiche (Création, modification, suppression, information), recevoir en copie CCI l'email sur l'adresse saisie (si vide, l'email ne vous sera pas envoyé en CCI).",
                    defaut: bddRef.paraAppli.mGetPara("portail_adresse_email_cci_email_technique"),
                    itemTemplate: function (itemData, contentElement) {
                        var dxAdrEmail = $("<div/>").appendTo(contentElement).dxCtrlTextEmail({
                            labelMode: 'floating',
                            label: "Adresse email (Si vide, pas d'envoi en CCI)",
                            width: "100%",
                            mode: "email",
                            value: Me.mGetPara(itemData.key),
                            onValueChanged: function (e) {
                                if (!dxAdrEmail.hasErreur) Me.mGetPara(itemData.key, e.value)
                            }
                        }).dxCtrlTextEmail("instance")
                    }
                })

                if (bddRef.objCptCli.objetMetier.hasEmail()) {
                    lstCleModuleDefaut.push({
                        isPara: true,
                        key: "dates_tournees_modele_email_envoi_feuille_de_route",
                        key_parent: "dates",
                        title: "Modèle email envoi feuille de route",
                        aide: "Definir le modèle du mail utilisé pour envoyer vos feuille de route.",
                        defaut: 'nZJda9swFIavZ/B/OPimF4sS58ttXccsTdySsTohSQe7Cop1vKjYlifJbtPR/z7ZXVkpG2wTAn29evSec5RHm830OiJ87kOAZ2M6HIxTNkSP0VMvTT3PHTJMvX26H47cD6UolUh1aFtsuo18uJK8A30XpqWEgTvwoH/uu+f+aATv3YHr2pa6vfwYzbY+2Fa+uIlIHa03i2XsQ79rTpNlvI3iLdFfVgaWV5nmJZW6RzONsqCa13hhW+/2oioYlceJQ9q2m+xifNArI925bn8370+96ex03D0fzmaD6Gzs2JZtbQ9cgen0FxhujAfIUSn6FbuNiJC/RL41q426d9B51hhMDlQq1BOnUoSqhHPnlXw9jTdX0ZpgPFvOF/G1D98qoZGRUvJC032GjZGgYYXBASkLgxw1hYLmOBnOT2qO96WQ+gQSUWgsdLN5z5k+YM0TJO20A7zgmtOMqGRiWzRrrpocn4RB75m5F+wISh/bEyc1KJLSnGdHH6g0FztwwKxGzRPaAUULRRRKnl4YWitW/BH9/qh8uHDCgPE6vBTFnahkJ+g1q3Yr2Mvw1fIzVjzL8BG0FFWNEhJuaJPB/E6YyCGjkD4rgCEYicbun2EzIZmxibnJwMubhtaOqqQFJBlVqonNVCMvmUicl4Qh422e28BpptAJv6/WUby82d1uF58WG/OXb9dPhhb0GlQI/0N8gzO0p5+43wfVayrSlKcp/D/8REJs6wc=',
                        itemTemplate: function (itemData, contentElement) {
                            $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                                bddCtrl: bddRef,
                                value: Me.mGetPara(itemData.key),
                                dataDefault: itemData.defaut,
                                allowSup: false,
                                tooltipModif: "Modifier le modele",
                                tooltipSupp: "Supprimer le modele",
                                tooltipNew: "Créer un nouveau modéle",
                                titlePopupEmail: itemData.title,
                                rempliTxtLib: function (contentElement, value) {
                                    var txtLib = ""
                                    txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                                    contentElement.html(txtLib)
                                },
                                onValueChanged: function (data64Signature) {
                                    debugger
                                    Me.mGetPara(itemData.key, data64Signature)
                                }
                            }).dxCtrlEmailData("instance")
                        }
                    })
                }

                if (typeof bddRef.utiCourantParaJson.parametre_general.libelle_destinataire_dates_tournee_contact_principal == 'undefined') {
                    bddRef.utiCourantParaJson.parametre_general.libelle_destinataire_dates_tournee_contact_principal = "Contact principal"
                    Me.mGetPara("libelle_destinataire_dates_tournee_contact_principal", bddRef.utiCourantParaJson.parametre_general.libelle_destinataire_dates_tournee_contact_principal)
                }
                if (typeof bddRef.utiCourantParaJson.parametre_general.libelle_destinataire_dates_tournee_contact_externe == 'undefined') {
                    bddRef.utiCourantParaJson.parametre_general.libelle_destinataire_dates_tournee_contact_externe = "Contact externe"
                    Me.mGetPara("libelle_destinataire_dates_tournee_contact_externe", bddRef.utiCourantParaJson.parametre_general.libelle_destinataire_dates_tournee_contact_externe)
                }
                if (typeof bddRef.utiCourantParaJson.parametre_general.libelle_destinataire_dates_tournee_contact_interne == 'undefined') {
                    bddRef.utiCourantParaJson.parametre_general.libelle_destinataire_dates_tournee_contact_interne = "Contact interne"
                    Me.mGetPara("libelle_destinataire_dates_tournee_contact_interne", bddRef.utiCourantParaJson.parametre_general.libelle_destinataire_dates_tournee_contact_interne)
                }
                lstCleModuleDefaut.push({
                    key: "libelle_destinataire_dates_tournee",
                    key_parent: "dates",
                    title: "Définir les libellés des destinataires des dates",
                    aide: "Définissez le libellé pour le contact principal de la date (destinataire de la date), pour les liste des contacts externes (interlocuteurs externes à votre structure) et pour les listes des contacts internes (interlocuteurs au sein de votre structure). Vous pouvez définir une autre destination à chaque type de destinataire.",
                    defaut: "",
                    type: "string",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlTextBox({
                            label: "Libellé contact principal",
                            labelMode: 'floating',
                            value: Me.mGetPara("libelle_destinataire_dates_tournee_contact_principal"),
                            onValueChanged: function (e) {
                                Me.mGetPara("libelle_destinataire_dates_tournee_contact_principal", (e.value ? e.value : ""))
                            }
                        }).dxCtrlTextBox("instance")
                        var dx = $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlTextBox({
                            label: "Libellé contact externe",
                            labelMode: 'floating',
                            value: Me.mGetPara("libelle_destinataire_dates_tournee_contact_externe"),
                            onValueChanged: function (e) {
                                Me.mGetPara("libelle_destinataire_dates_tournee_contact_externe", (e.value ? e.value : ""))
                            }
                        }).dxCtrlTextBox("instance")
                        var dx = $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlTextBox({
                            label: "Libellé contact interne",
                            labelMode: 'floating',
                            value: Me.mGetPara("libelle_destinataire_dates_tournee_contact_interne"),
                            onValueChanged: function (e) {
                                Me.mGetPara("libelle_destinataire_dates_tournee_contact_interne", (e.value ? e.value : ""))
                            }
                        }).dxCtrlTextBox("instance")
                    }
                })


                if (typeof bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_nomstr == 'undefined') {
                    bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_nomstr = 1
                    Me.mGetPara("dates_tournee_feuille_affiche_nomstr", bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_nomstr)
                }
                if (typeof bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_nomcontact == 'undefined') {
                    bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_nomcontact = 1
                    Me.mGetPara("dates_tournee_feuille_affiche_nomcontact", bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_nomcontact)
                }
                if (typeof bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_fonction == 'undefined') {
                    bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_fonction = 0
                    Me.mGetPara("dates_tournee_feuille_affiche_fonction", bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_fonction)
                }
                if (typeof bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_tel == 'undefined') {
                    bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_tel = 1
                    Me.mGetPara("dates_tournee_feuille_affiche_tel", bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_tel)
                }
                if (typeof bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_mobile == 'undefined') {
                    bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_mobile = 1
                    Me.mGetPara("dates_tournee_feuille_affiche_mobile", bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_mobile)
                }
                if (typeof bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_email == 'undefined') {
                    bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_email = 1
                    Me.mGetPara("dates_tournee_feuille_affiche_email", bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_email)
                }
                if (typeof bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_adresse == 'undefined') {
                    bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_adresse = 0
                    Me.mGetPara("dates_tournee_feuille_affiche_adresse", bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_adresse)
                }
                if (typeof bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_siteweb == 'undefined') {
                    bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_siteweb = 0
                    Me.mGetPara("dates_tournee_feuille_affiche_siteweb", bddRef.utiCourantParaJson.parametre_general.dates_tournee_feuille_affiche_siteweb)
                }
                lstCleModuleDefaut.push({
                    key: "affiche_feuille_dates_tournee",
                    key_parent: "dates",
                    title: "Informations affichées pour les destinataires dans la feuille de routes",
                    aide: "Définissez quelles informations afficher pour chaque destinataire affiché dans la feuille de routes généré/imprimer.",
                    defaut: "",
                    type: "string",
                    itemTemplate: function (itemData, contentElement) {
                        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        $("<div/>").appendTo($Td).dxCtrlSwitch({
                            value: (Me.mGetPara("dates_tournee_feuille_affiche_nomstr") == "1" || Me.mGetPara("dates_tournee_feuille_affiche_nomstr") == null),
                            onValueChanged: function (e) {
                                Me.mGetPara("dates_tournee_feuille_affiche_nomstr", ((e.value) ? "1" : "0"))
                            }
                        })
                        var $Td = $("<td style='width:100%;font-family:barlow condensed;'>Afficher le nom de la structure</td>").appendTo($Tr)

                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        $("<div/>").appendTo($Td).dxCtrlSwitch({
                            value: (Me.mGetPara("dates_tournee_feuille_affiche_nomcontact") == "1" || Me.mGetPara("dates_tournee_feuille_affiche_nomcontact") == null),
                            onValueChanged: function (e) {
                                Me.mGetPara("dates_tournee_feuille_affiche_nomcontact", ((e.value) ? "1" : "0"))
                            }
                        })
                        var $Td = $("<td style='width:100%;font-family:barlow condensed;'>Afficher le nom & prénom du contact</td>").appendTo($Tr)

                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        $("<div/>").appendTo($Td).dxCtrlSwitch({
                            value: (Me.mGetPara("dates_tournee_feuille_affiche_fonction") == "1" || Me.mGetPara("dates_tournee_feuille_affiche_fonction") == null),
                            onValueChanged: function (e) {
                                Me.mGetPara("dates_tournee_feuille_affiche_fonction", ((e.value) ? "1" : "0"))
                            }
                        })
                        var $Td = $("<td style='width:100%;font-family:barlow condensed;'>Afficher la fonction du contact</td>").appendTo($Tr)

                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        $("<div/>").appendTo($Td).dxCtrlSwitch({
                            value: (Me.mGetPara("dates_tournee_feuille_affiche_tel") == "1" || Me.mGetPara("dates_tournee_feuille_affiche_tel") == null),
                            onValueChanged: function (e) {
                                Me.mGetPara("dates_tournee_feuille_affiche_tel", ((e.value) ? "1" : "0"))
                            }
                        })
                        var $Td = $("<td style='width:100%;font-family:barlow condensed;'>Afficher le téléphone du contact</td>").appendTo($Tr)

                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        $("<div/>").appendTo($Td).dxCtrlSwitch({
                            value: (Me.mGetPara("dates_tournee_feuille_affiche_mobile") == "1" || Me.mGetPara("dates_tournee_feuille_affiche_mobile") == null),
                            onValueChanged: function (e) {
                                Me.mGetPara("dates_tournee_feuille_affiche_mobile", ((e.value) ? "1" : "0"))
                            }
                        })
                        var $Td = $("<td style='width:100%;font-family:barlow condensed;'>Afficher le mobile du contact</td>").appendTo($Tr)

                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        $("<div/>").appendTo($Td).dxCtrlSwitch({
                            value: (Me.mGetPara("dates_tournee_feuille_affiche_email") == "1" || Me.mGetPara("dates_tournee_feuille_affiche_email") == null),
                            onValueChanged: function (e) {
                                Me.mGetPara("dates_tournee_feuille_affiche_email", ((e.value) ? "1" : "0"))
                            }
                        })
                        var $Td = $("<td style='width:100%;font-family:barlow condensed;'>Afficher l'adresse email du contact</td>").appendTo($Tr)

                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        $("<div/>").appendTo($Td).dxCtrlSwitch({
                            value: (Me.mGetPara("dates_tournee_feuille_affiche_adresse") == "1" || Me.mGetPara("dates_tournee_feuille_affiche_adresse") == null),
                            onValueChanged: function (e) {
                                Me.mGetPara("dates_tournee_feuille_affiche_adresse", ((e.value) ? "1" : "0"))
                            }
                        })
                        var $Td = $("<td style='width:100%;font-family:barlow condensed;'>Afficher l'adresse postale du contact</td>").appendTo($Tr)

                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        $("<div/>").appendTo($Td).dxCtrlSwitch({
                            value: (Me.mGetPara("dates_tournee_feuille_affiche_siteweb") == "1" || Me.mGetPara("dates_tournee_feuille_affiche_siteweb") == null),
                            onValueChanged: function (e) {
                                Me.mGetPara("dates_tournee_feuille_affiche_siteweb", ((e.value) ? "1" : "0"))
                            }
                        })
                        var $Td = $("<td style='width:100%;font-family:barlow condensed;'>Afficher le site web du contact</td>").appendTo($Tr)
                    }
                })

                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "config_acces_portail_externe",
                    key_parent: "dates",
                    title: "Définir les valeurs par défaut des droits d'accès au portail",
                    aide: "Définissez ce qui est affiché sur le portail des dates et tournées pour les contacts à qui vous donnez l'accès. Vous pourrez personnaliser les droits pour chaque contact au moment de la création de leur accès au portail.",
                    defaut: JSON.parse(JSON.stringify(jsonDefautAccesPortail)),
                    type: "json",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div style='margin-top:10px;'/>").appendTo(contentElement).dxCtrlConfigPortail({
                            bddCtrl: bddRef,
                            json: Me.mGetPara(itemData.key),
                            onValueChanged: function (json) {
                                //dx.mChangeDisabled(true)
                                Me.mGetPara(itemData.key, json)//, function () { dx.mChangeDisabled(false) })
                            }
                        }).dxCtrlConfigPortail("instance");
                    }
                })

            }

            ////DOCPT GENERAL
            //durée avoir
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_duree_avoir_mois",
                key_parent: "doccpt_general",
                title: "Durée des avoirs",
                aide: "Quand vous annuler ou faites des retours sur une facture, vous pouvez rembourser le client ou générer un avoir client a utiliser ultérieurement. Cette avoir a une durée de validité que vous pouvez définir ici (en nombre de mois).",
                defaut: 12,
                type: "int",
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlNumberBox({
                        label: "Durée avoir (mois)",
                        labelMode: 'floating',
                        width: 240,
                        isFloat: false,
                        min: 1,
                        value: Me.mGetPara(itemData.key),
                        onValueChanged: function (e) {
                            //dx.component().option("disabled", true)
                            Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
                        },
                        buttons: [{
                            focusStateEnabled: false,
                            name: 'moins',
                            location: 'before',
                            options: {
                                icon: 'spinprev',
                                stylingMode: 'text',
                                onClick() {
                                    if (dx.option("value") == null) { dx.option("value", 1) }
                                    else {
                                        if (dx.option("value") - 1 >= 0) dx.option("value", dx.option("value") - 1)
                                    }
                                },
                            },
                        }, {
                            focusStateEnabled: false,
                            name: 'plus',
                            location: 'after',
                            options: {
                                icon: 'spinnext',
                                stylingMode: 'text',
                                onClick() {
                                    if (dx.option("value") == null) { dx.option("value", 1) }
                                    else { dx.option("value", dx.option("value") + 1) }
                                },
                            },
                        }]
                    }).dxCtrlNumberBox("instance")
                }
            })
            //modèle avoir
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_cb_modele_print_avoir",
                key_parent: "doccpt_general",
                title: "Modèle du contenu des avoirs",
                aide: "Définissez ici ce que vous voulez voir imprimé sur votre avoir. A la suite de ce contenu est imprimé le montant de l'avoir, sa date d'expiration et son code unique pour le retrouver parmi vos avoirs.",
                defaut: 'rZRbb5swGIavh8R/sLjpxeoGk6RdKEHLgVapVqgK27SryBgnscZp2KHtqv332TRpsybrYR1CgOyXR+/72f4yLwwHpx5kYxs4HTQj7R7G5oceah+huEt6h7SHk6NOD5kWJR/LouTFTLi6lgwizwYhFvsAIXC2TIFlWocAdW0L2R0E3puWaeoa/zw880aRDQZ1wSpdyybnHqy9y3AS+DZAB1JCAj/y/AiKbxeSmC1TwUpciRZOBa1yLFhNj3XtXVws8wRXN30DNte0P/XptbiQ0qlpoukQtVG3PfIOumb7cHh0Yhm6pmvRgnEgb/wABufSA8go53hOD5QIwhciH5sVUt1aiCxVBskCV5yKvrHkEHPCmLEhvxz44Yl3Cak/CsYT/9QGP5aFoAksK5YLHKdUGXEUy3UWFCeuk1GBQY4z2m+P92pGr8qiEnuAFLmguVCDVywRC1ozQmHzuQ9YzgTDKeSkr2s4Vb/KGu+5TuuOGRfJDeDippkxYky+zytVV0iKtKjsqwUT9NhwnYTVzWOl1TUlV2khTtk8twGRFmh1bIAECwwz6eCeukvmOrzEOSAp5nxFk+XKyqQgxjoRTVhTCDU5wymnxhNOwcoqkLRtC3+Vu7efgtNgGgajiRd5v5yWsiWrs84raZu53xha0jZzvyy0e+sH57scSlr9/8w1SRtz97KZtAQ5+0nlwbTK652oLc0dRNJeGTKcRN70qzfcTspLtXc3V+VtgSXtz134psCSJjlx9SCNi/myyY0Md2tDPWN95+594gA9bV3V7bnl+lKIigKsuvEzZtU5tcb/et7jag2+e6qk6v14/PGg6lCqXalG+IrODKGu/QY=',
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                        bddCtrl: bddRef,
                        value: Me.mGetPara(itemData.key),
                        dataDefault: itemData.defaut,
                        allowSup: false,
                        tooltipModif: "Modifier le modele",
                        tooltipSupp: "Supprimer le modele",
                        tooltipNew: "Créer un nouveau modéle",
                        titlePopupEmail: itemData.title,
                        showObjet: false,
                        hideAddFile: true,
                        rempliTxtLib: function (contentElement, value) {
                            var txtLib = ""
                            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                            contentElement.html(txtLib)
                        },
                        onValueChanged: function (data64Signature) {
                            debugger;
                            Me.mGetPara(itemData.key, data64Signature)
                        }
                    }).dxCtrlEmailData("instance")
                }
            })
            var dataArticleBonCadeau = bddRef.getObjet("article", 808)
            if (dataArticleBonCadeau) {
                //durée bon cadeau
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "doccpt_general_duree_boncadeau_mois",
                    key_parent: "doccpt_general",
                    title: "Durée des bons cadeaux",
                    aide: "Quand vous cendez un bon cadeau, celui-ci a une durée de validité en nombre de mois. A l'issue de cette durée, le bon cadeau est perdu pour le client et purgé automatiquement.",
                    defaut: 12,
                    type: "int",
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCtrlNumberBox({
                            label: "Durée bon cadeau (mois)",
                            labelMode: 'floating',
                            width: 240,
                            isFloat: false,
                            min: 1,
                            value: Me.mGetPara(itemData.key),
                            onValueChanged: function (e) {
                                //dx.component().option("disabled", true)
                                Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
                            },
                            buttons: [{
                                focusStateEnabled: false,
                                name: 'moins',
                                location: 'before',
                                options: {
                                    icon: 'spinprev',
                                    stylingMode: 'text',
                                    onClick() {
                                        if (dx.option("value") == null) { dx.option("value", 1) }
                                        else {
                                            if (dx.option("value") - 1 >= 0) dx.option("value", dx.option("value") - 1)
                                        }
                                    },
                                },
                            }, {
                                focusStateEnabled: false,
                                name: 'plus',
                                location: 'after',
                                options: {
                                    icon: 'spinnext',
                                    stylingMode: 'text',
                                    onClick() {
                                        if (dx.option("value") == null) { dx.option("value", 1) }
                                        else { dx.option("value", dx.option("value") + 1) }
                                    },
                                },
                            }]
                        }).dxCtrlNumberBox("instance")
                    }
                })
                //modèle bon cadeau
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "doccpt_cb_modele_print_boncadeau",
                    key_parent: "doccpt_general",
                    title: "Modèle du contenu des bons cadeaux",
                    aide: "Définissez ici ce que vous voulez voir imprimer sur votre bon cadeau. A la suite de ce contenu est imprimé le montant du bon cadeau, sa date d'expiration et son code unique pour le retrouver parmi vos bons cadeaux.",
                    defaut: 'rZRfb5swFMWfh8R3sHjpw+oGaEkaStC6wKpMC1QN2rSn6GLcxhr/hk3arNp3n03bNF2yqlWHEELXh5/OuVy7CGez07MQs8BFnuUMwOwTIGnqOP2hk5IBObQyyzGPjq3hcf9DXdW8uhS+rmWnSeiipKX7yLbQ5zZHtmn3kdV3Hdt1HPTetE1T14rJNMTL8GI2iSMXWQeyROIoCaMEi+/nklC0uWA1NKIHuaBNCYIt6YmuvUurtsygWY0M3F3z0TyiN+JcSuemac2DYRAGzmB4MBiPzcG4f2Tomq4lC8aRvOERjKbSAyoo53BFD5QI4xci/zYrpLq3EEWuDJIFNJyKkdFyDJwwZmzIL06j2afwAtNoHAeT6MxFP9tK0AzXDSsFpDlVRjzF8r0Fhcz3CioAlVDQ0WGwt2T0uq4asYdIVQpaClW8ZplY0CUjFHev+4iVTDDIMScjXYNcfSp7vOd7vTtmWmUrxMWqWzFSID+uGtVXTKq8atzrBRP0xPC9jC27x71W15RcpcWQs6vSRURaoM2JgTIQgAvpYE3dJfM9XkOJSA6c39Nku4o6q4jxkIhmrGuEWryEnFPjGafo3iqStG0L/5T7t1/is3g+i8eTMAl/ez1lS3bnIa+kbeZ+Y2hJ28z9stD+bRRPdzmUtOX/M9cl7cytZZfSEubsF5Ub065vdqK2NHcQSXtlyNkkCeffwo/bSXmtZnfzr7wtsKStpzBt3opV02sHu8f79Z2UtCfN/FqJhqK0kiMDGYV2a0Cf9SxpL9+Qj61Yw58WJW1XXR0h6jxRJ9Urjk6Mde0P',
                    itemTemplate: function (itemData, contentElement) {
                        $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                            bddCtrl: bddRef,
                            value: Me.mGetPara(itemData.key),
                            dataDefault: itemData.defaut,
                            allowSup: false,
                            tooltipModif: "Modifier le modele",
                            tooltipSupp: "Supprimer le modele",
                            tooltipNew: "Créer un nouveau modéle",
                            titlePopupEmail: itemData.title,
                            showObjet: false,
                            hideAddFile: true,
                            rempliTxtLib: function (contentElement, value) {
                                var txtLib = ""
                                txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                                contentElement.html(txtLib)
                            },
                            onValueChanged: function (data64Signature) {
                                debugger;
                                Me.mGetPara(itemData.key, data64Signature)
                            }
                        }).dxCtrlEmailData("instance")
                    }
                })
            }

            ////modèle email envoi facture brouillon

            //////DOCCPT CB
            ////fond écran CB
            //lstCleModuleDefaut.push({
            //    isPara: true,
            //    key: "doccpt_general_data_url_base64_image_fond_cb",
            //    key_parent: "doccpt_cb",
            //    title: "Image d'arrière plan CB internet",
            //    aide: "Quand l'écran de règlement CB s'affiche, la saisie se fait sur un fond noir. Vous pouvez choisir une image qui sera affiché en fond.",
            //    defaut: "",
            //    itemTemplate: function (itemData, contentElement) {
            //        mRempli()
            //        function mRempli() {
            //            contentElement.empty()
            //            if (Me.mGetPara(itemData.key).length == 0) {
            //                var $A = $("<a href='javascript:void(0)'>Choisir une image</a>").appendTo(contentElement)
            //                $A.on("click", function () { mDisplayCb() })
            //            } else {
            //                var dataImg = Me.mGetPara(itemData.key)
            //                var opacity = dataImg.split("|")[0]
            //                dataImg = dataImg.split("|")[1]
            //                var fichier = new cFichier(bddRef, dataImg)
            //                var $DivImg = $("<div style='width:100%;max-width:200px;opacity:" + (opacity / 100) + ";'/>").appendTo(contentElement)
            //                var $elementImage = fichier.mGetElementImage($DivImg.outerWidth() - 3, $DivImg.outerWidth() - 3, false).appendTo($DivImg)
            //                //$elementImage.css({ "border-radius": ((typeof option.borderRadius == 'undefined') ? "0" : option.borderRadius + "px") })
            //                if (!fichier.mIsImage()) $elementImage.css({ "width": "100%", "max-width": "", "height": "100%", "font-size": ($DivImg.innerWidth() * 2 / 3) + "px", "display": "flex", "align-items": "center", "justify-content": "center" })
            //                $elementImage.addClass("state-hover")
            //                $elementImage.on("click", function () { mDisplayCb() })
            //                var $A = $("<a href='javascript:void(0)'>Modifier image et opacité</a>").appendTo(contentElement)
            //                $A.on("click", function () { mDisplayCb() })
            //            }

            //            function mDisplayCb() {
            //                if (bddRef.mGetArray("societe").length == 0) {
            //                    //pas de societe
            //                    mNotify("Vous n'avez pas de société<br/><a href='javascript:void(0)'>Cliquez pour créer votre société</a>", "warning", 6000, function () {
            //                        var dataSociete = bddRef.getObjet("societe").mGetNewData()
            //                        bddRef.getObjet(dataSociete).mShowPopup()
            //                        if (contentElement.closest(".dx-popup-content").length > 0) $("body").find("." + contentElement.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance").hide()
            //                    })
            //                } else if (bddRef.mGetArray("societe")[0].has_cle_stripe == "0") {
            //                    //pas de clé stripe
            //                    mNotify("Vous n'avez pas configuré les paiements internets sur votre société<br/><a href='javascript:void(0)'>Cliquez pour configurer votre société</a>", "warning", 6000, function () {
            //                        bddRef.getObjet(bddRef.mGetArray("societe")[0]).mShowPopup()
            //                        if (contentElement.closest(".dx-popup-content").length > 0) $("body").find("." + contentElement.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance").hide()
            //                    })
            //                } else {
            //                    //test des clés stripe
            //                    $("<div/>").appendTo("body").dxCtrlPageSaisieCbStripe({
            //                        bddCtrl: bddRef,
            //                        isPreview: true,
            //                        amount100: 100,
            //                        id_societe: bddRef.mGetArray("societe")[0].id_societe,
            //                        onValidePaiement: function () { },
            //                        onChangeImageFond: function () { mRempli() }
            //                    }).dxCtrlPageSaisieCbStripe("instance")
            //                }
            //            }
            //        }

            //    }
            //})
            //adresse email info paiement CB
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_cb_adresse_email_information_paiement_cb",
                key_parent: "doccpt_cb",
                title: "Envoyer un email d'information paiement CB internet",
                aide: "Quand un client vous fait un règlement CB par internet (sur un devis/commande/facture ou un service), un email est envoyé pour vous informer de ce règlements. Préciser à cet endroit si vous voulez recevoir ce mail et préciser l'adresse email où recevoir ces messages (par défaut, ce sera l'adresse de votre compte client).",
                defaut: "",
                itemTemplate: function (itemData, contentElement) {
                    var $Table = $("<table/>").appendTo(contentElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                    var dxSwitchSendEmail = $("<div style='padding-top:5px;'/>").appendTo($Td).dxCtrlSwitch({
                        value: ((Me.mGetPara(itemData.key).length == 0) ? true : Me.mGetPara(itemData.key).split("|")[0] == "1"),
                        onValueChanged: function (e) {
                            //dxSwitchSendEmail.component().option("disabled", true)
                            Me.mGetPara(itemData.key, ((e.value) ? "1" : "0") + "|" + dxAdrEmail.option("value")) //, function () { dxSwitchSendEmail.component().option("disabled", false) })
                            dxAdrEmail.option("disabled", !e.value)
                        }
                    }).dxCtrlSwitch("instance")
                    var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
                    var dxAdrEmail = $("<div/>").appendTo($Td).dxCtrlTextEmail({
                        labelMode: 'floating',
                        label: "Adresse email",
                        placeholder: "Si vide, les message sont envoyé sur l'adresse email de votre compte client...",
                        width: "100%",
                        mode: "email",
                        value: ((Me.mGetPara(itemData.key).length == 0) ? "" : Me.mGetPara(itemData.key).split("|")[1]),
                        onValueChanged: function (e) {
                            if (!dxAdrEmail.hasErreur) Me.mGetPara(itemData.key, "1|" + ((e.value == null) ? "" : e.value))
                        }
                    }).dxCtrlTextEmail("instance")
                }
            })
            //modèle email envoi facture/ticket client paiement CB
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_cb_modele_email_envoi_doccpt_reglement_cb_internet",
                key_parent: "doccpt_cb",
                title: "Modèle email envoi factures et tickets au client après règlement CB internet",
                aide: "Quand un client règle un document comptable par CB internet, un email lui est envoyé avec le document en pièce jointes. Ce modèle sera utilisé pour remplir le mail qui sera envoyé.",
                defaut: 'pZXRcto4FIavywzvoPHF5qIIbALBOJgsATVDJ4EsOLuzVx5hi6DWtlxLOE07ffc9MqEkJtmQlmEssI8//efX0VFM5vPBBcF85KCebbNlZ9m2rfYy7LTsjt3snLSsrhl07JPF8UnwZypSKZaqX62EA4846EPGa8gy0SDNUNNsniCr65jHTttE782maVYr8ub8Ixl6DnLPuBTYtttdbJ39dfa3UBnzlzRQaxjlmivmu8T08+J+xm4jFrNE+SnN/OH5mVutxOMrgnMym4+nEwdZdYAH04lHJh5W/16DlngdKQ7xqkEjxbKEKp6z02rl3UKsk5Bm966Bi4/v+hP2VV1DqG+alt8irfawaY7qlmmZnUGXGNVKteKtuETwpTswugINKGZS0ltW10EYH4gsi1UQ3VipONICgxXNJFOusbPIePTCbDCZfyAzzCbD6Wg8uXDQl7VQLMRpxhNFFxHTUnqa1u+tGA37vZgpihIaM/d4dJRzdpeKTB2hQCQKXNU373ioViznAcPFzxriCVecRlgG4DaN9Kvg8lG/19gwFyK8R1LdF0+MBQ0+32baWRyISGTO3QrW8NTo90KeP1xkShMkgbZ9aQnzY8m/MVjAVvr11EAhVRTHIEK+GNM/F8knsc5qvQYAgZaApN0ki+zJ382cB09YrTw/51xXJIKKREVFoswl9kNNIigFFMBKM7SgSUA5PIZ1gIoDGlM1lLM1jyL2DSnwJ2cQzPEnASEPrIeqr/+RLGR6urkWuT1NDGi/l9uTGKBtc/stziYGaEb/imUBR+ERzQWHJFeCS46SIkWXdHVhcikLy+o/09sMpZSAFkRUSj0T7IU4DUVgbIuVhbyo8UIGjSQz+t8vpxdTfz4djolHfpStA9oW/DbqZHq1DwXaTi2L/8+85uvmAW0T9ksCr2dEa7zxxpfjOfRfoN3MtlLRr6a8xQGN7HA/B53zQTX4NH29s5qjlwPfZkDRkQrFg9EMTiyyXSiHhtZWcu1QC/Q+fexCmRmkbzFV97eyr2VirhvCnrXPurrfkQ6oq5c81b69XgUeuSwXPmo8k7o+hV+Fzcce8f8h5/tbqZQ10B537/1rqb039AGkTyN9zr3h6MW4WvkP',
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                        bddCtrl: bddRef,
                        value: Me.mGetPara(itemData.key),
                        dataDefault: itemData.defaut,
                        allowSup: false,
                        tooltipModif: "Modifier le modele",
                        tooltipSupp: "Supprimer le modele",
                        tooltipNew: "Créer un nouveau modéle",
                        titlePopupEmail: itemData.title,
                        rempliTxtLib: function (contentElement, value) {
                            var txtLib = ""
                            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                            contentElement.html(txtLib)
                        },
                        onValueChanged: function (data64Signature) {
                            Me.mGetPara(itemData.key, data64Signature)
                        }
                    }).dxCtrlEmailData("instance")
                }
            })
            //modèle email envoi demande de reglement CB avec lien internet CB
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_cb_modele_email_envoi_lien_reglement_cb_internet",
                key_parent: "doccpt_cb",
                title: "Modèle email envoi lien de règlement CB internet",
                aide: "Quand vous êtes sur une facture ou un ticket, vous pouvez envoyer un email a votre client avec un lien de règlement CB pour le ticket. Ce modèle sera utilisé pour remplir le mail d'envoi de ce lien. Le lien de paiement est rajouté à la fin du message.",
                defaut: 'pZTbctowEIavywzvsOObXDQKhpIADodCMBkyDaTgptMrj7AXUCsfIsnk0Om7V3JCEkjakinj8dhG++2/u78UudNp99QlrO9A86hSo4j2DBsVPLKx2sDDwyrFOa1X7bpN5x/TJJXJXLWLhbDruQ54y2wfKh/gLONQsStHUK451YZj1+C9XbHtYkF+6Z25J54DrQ6TCanXDxuk3PncuUyUQJ8zjP00yYS/yt9Fy60vOEYYK/+k57NYoYhRdVrFQjQ8d8nKnUyH45ED5QPNDsYjzx15RH270FKijCuWUqFKlJswqtgKj4uFd7Mki0MqblsWyX9+yx/hjbrQS33bLvu9crk/qPQHB4OjSr9WH9StYqFY8JZMgr7oExjOtQaIUEq6wAOziJAdkdtilV5dWqqIG4HBkgqJqmU9dch6FjDpjqYDd0JwdDLuD0enDlxlicKQpEI3iM44GilNQ2s3l0jDdjNCRSGmEbY+9PdWDK/TRKg9CBLd0FiZj9csVEtcsQBJ/rgPLGaKUU5koLtNuQnVXd5rN0v3zFkS3oJUt/k/1owGPxbCdJYECU+Ec71kCo+tdjNkq4ebTGkMUtPWQXOdn0h2h3qA1fTm2IKQKkoiLUL+cU27l8TftUX2myUN1LRYS3pKMhMbr/c5d05YLLye8xIzxjneQcDZVYYCZCaAIxjDQsu1gVOYsxhChACVQsCIMk3jYNwMOJ9joExc7mtIKctNrR8EBNolCDMaB5QJzKt6rSRNe/xyX5oSSbx4KDHgVEqjXZsnSsMksNbTxZDlpsgLo1yi1f45GmvauT8dnwxdz/31mHONfGsDzX78+9DeolLT1kK7/Yk+j9y1UoeG5bXafdiNaaawUfw2M0jXyB2IZgov2rlNXBmvPOvq9kAfe6pp/7ERttVq2i7D99xP25OH0svSza7/N2w69Fz/q9t7xUsbVWvaxubcuJujxJwr5sR6wyFKSLHwGw==',
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                        bddCtrl: bddRef,
                        value: Me.mGetPara(itemData.key),
                        dataDefault: itemData.defaut,
                        allowSup: false,
                        tooltipModif: "Modifier le modele",
                        tooltipSupp: "Supprimer le modele",
                        tooltipNew: "Créer un nouveau modéle",
                        titlePopupEmail: itemData.title,
                        rempliTxtLib: function (contentElement, value) {
                            var txtLib = ""
                            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                            contentElement.html(txtLib)
                        },
                        onValueChanged: function (data64Signature) {
                            debugger;
                            Me.mGetPara(itemData.key, data64Signature)
                        }
                    }).dxCtrlEmailData("instance")
                }
            })
            //image fond paiement CB internet
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_cb_list_image_arriere_plan",
                key_parent: "doccpt_cb",
                title: "Image de fond de la page de reglement CB",
                aide: "Choisissez une image de fond pour la page de règlement CB internet.",
                defaut: '',
                itemTemplate: function (itemData, contentElement) {
                    var $TableImage = $("<table style='width:100%;margin:8px 0;'/>").appendTo(contentElement)
                    var $TrImg = $("<tr/>").appendTo($TableImage)
                    var $TdImg = $("<td style='width:100%;'/>").appendTo($TrImg)
                    var dxTextBoxLink = $("<div/>").appendTo($TdImg).dxCtrlTextBox({
                        bddCtrl: bddRef,
                        labelMode: "floating",
                        label: "Lien sur une image pour illustrer la page",
                        value: Me.mGetPara(itemData.key),
                        onValueChanged: function (e) {
                            var lien = ((e.value == null) ? "" : e.value)
                            if (!lien.startsWith("http://") && !lien.startsWith("https://") && !lien.startsWith("ftp://") && !lien.startsWith("ftps://")) {
                                lien = "http://" + lien
                            }
                            Me.mGetPara(itemData.key, lien)
                        }
                    }).dxCtrlTextBox("instance")
                    var $TdImg = $("<td style='width:1px;'/>").appendTo($TrImg)
                    $("<div/>").appendTo($TdImg).dxCtrlButton({
                        icon: "fas fa-boxes",
                        hint: "Choisissez un fichier dans votre box<br/>(Vous pouvez choisir un fichier image dans votre box publique. si le fichier est sur votre machine, il vous suffit de le déposer dans le répertoire public de votre box, puis de le sélectionner)",
                        onClick: function (e) {
                            var pop = $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                                bddCtrl: bddRef,
                                machine: false,
                                box: true,
                                icone: false,
                                imgInternet: false,
                                docCpt: false,
                                courrier: false,
                                multiple: false,
                                optionBox: {
                                    allowRepertoirePublic: true,
                                    allowRepertoirePartage: false,
                                    allowRepertoireUti: false
                                },
                                onValide: function (lstUrlFile) {
                                    if (lstUrlFile.length > 0) {
                                        var fic = new cFichier(bddRef, lstUrlFile[0])
                                        var url = fic.urlPublicAbsolue()
                                        if (url.length > 0) {
                                            dxTextBoxLink.option("value", url)
                                            mNotify("Vous avez inséré un lien sur un document de votre box public", "success", 6000)
                                        }
                                    }
                                    pop.hide();
                                }
                            }).dxCtrlFileUploaderPopup("instance")
                        }
                    })
                }
            })

            ////DOCCPT DEVIS
            //modèle email envoi devis brouillon
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_modele_email_envoi_doccpt_devis_brouillon",
                key_parent: "doccpt_devis",
                title: "Modèle email envoi devis brouillon",
                aide: "Definir le modèle du mail utilisé pour envoyer vos devis brouillon.",
                defaut: 'pZVdb9owFIavFyn/wcrFejEMSQoUwodGIa2Y2lBB2mlXyCRu8ZbEWWzox7T/vuNQ2vLRFjqEkhCOn/Oe18d27I5GnVMXs56DmkdWpVotW3aNEkKOKrVK3bLDsGaZlfJhjdRrX1OeCn4t27oWdnzXQScZKyDLRJ00Q7ZpV5FVd8yKU66iL6ZtmromLo+/uV3fQVdcZhSFdM4EmmR8xqKIJ7oW989dPHeHo/7Ac5BVhCHBwPNdz8fyxwVkiGeRZCnJZIlEkmYJkWxOG7r2acJnSUiy+5aB88+4NfbonbyA0LFpWuPDbqdSr9ftom3WOp1u+cjQNV3zp5AfvuQZjM5BA4qpEOSGFlUQxjsi18VKiC5NZRwpgcGUZILKljETmIiAMeNF+LDjjU7cIaZed9Dre6cO+j3jkoY4zVgiySSiSkhTsdrNKSVhuxlTSVBCYto67B3MGb1NeSYPUMATSROpXt6yUE7B4YDi/LGAWMIkIxEWQUvXSKSGgscH7WZpwZzw8B4JeZ//Y0xI8OsmU77igEc8c26nTNKG0W6GbP54ESlJkADactA15MeCPVCYvnJ61zBQSCTBMYgQr8a0j3nyk8+yQrMEQKAlIOk5ySRb+bnIuXNCXdue84qqrqMPSEKNc5qhgOGfHOxG823NWfycTEQKtEb+0Mil/qdO5du73uxcr6rU7r1B6vIshOmnMTTIk/zF7Vn18gK0x9RBRIRQRGjhOA15YCy7jIYsb848HYkENdp/zgang/Fo0O27vvv3KQvQ1ozZj+oNzl9AgbZhPo3fcsp+oxUffXsR+CGJF0NXqQTapd8/649gR7wcLh1AHywaaOMtuKebqnqnlsvrAto7y3Gf8oG2qrfTG8Lx4S4nyiGhtRRceNcAoG3zYJ0ZpDtZqlbWK66uE+dqF9gwdsVTtSPt31eveaq6d+ce8N2z9dWESiulL/a3nWCjvu+Ov7vHm+tzWTXQtmxnm9etARsvX6GpY0adOeo02+N4xVjX/gE=',
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                        bddCtrl: bddRef,
                        value: Me.mGetPara(itemData.key),
                        dataDefault: itemData.defaut,
                        allowSup: false,
                        tooltipModif: "Modifier le modele",
                        tooltipSupp: "Supprimer le modele",
                        tooltipNew: "Créer un nouveau modéle",
                        titlePopupEmail: itemData.title,
                        rempliTxtLib: function (contentElement, value) {
                            var txtLib = ""
                            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                            contentElement.html(txtLib)
                        },
                        onValueChanged: function (data64Signature) {
                            Me.mGetPara(itemData.key, data64Signature)
                        }
                    }).dxCtrlEmailData("instance")
                }
            })
            //modèle email envoi devis validé
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_modele_email_envoi_doccpt_devis_valide",
                key_parent: "doccpt_devis",
                title: "Modèle email envoi devis validée",
                aide: "Definir le modèle du mail utilisé pour envoyer vos devis validés.",
                defaut: 'rZVbb9owFMefh8R3sPKwPgxDAhRBuI2CWzG10EHaaU/IxKa4y22xSS9Tv/uOA6wtl4pWQ8iB5OR3/ufvY9sn43HnjGDRs1GDVSvurGzNrHLFYlOzVKwwl1WrpTI1WZXXKl+jMJLhTLWyGdZxiI1OY5FDlok6UYyKZrGCrJptVmyrir6YRdPMZuTVyTfSdWzUbAsZ4mr1uIat9vf2dahiPmE8EXKSUE+wJqm1m9mM378gOCGjcX84sJGVB4Q7HDhk4GD18xIy+gtPiYjGqkA9xeOAKpHwejbzaRouAkbjh6aB08+kORnwe3UJoRPTtCaWVSS1Tu84XzFJqWZWK0Y2k804cyERfOkzGF2ABuRzKekNz+sgjA9EbopVEF2YK9/TAt05jSVXTWMhMZWuEMaL8FFnMD4lI8wH3WGvPziz0e9FqDjDUSwCRace10IamtVqzDllrYbPFUUB9Xmz1DtKBL+LwlgdITcMFA+UvnknmJqDxS7H6c8cEoFQgnpYuuA19fSr4PFRq1FYMqche0BSPaRPjCl1f93E2lfshl4Y23dzoXjdaDWYSFaDjGiAJNDWL80gP5bikcP0laP7uoEYVRT7IELujWmdhMFtuIhzjQIAgRaApOck0/jV32XOgxNmM7tzXvOF8Dz+iBTUmPAYuQLfhmA3SnR3orQ785+DqYzqyxHUAQ2y/y91QNvnyHurhBigbXO6YcxgyrkPTZG6q8UvL8+aN9S7HpVy5Ru0rR+x0DXWncWZSBsyVUU9yY3Wn/Ph2XAyHnb7xCFP/7K8pOp+W4MPpQ6GF3ugQEuv3H/Lp+IB7adjgGa8qvxQgZcjojVeOf3z/hg2xKsR6ARaKhV9hLiFA9rrSSvomg9qtx3lA2132IfKB1qnN4IDhKynyabMWk9V7p0G6LWQYjeZbrRGHk5crXm6m5jodf+0sRr2ewq0D3TVPk+B9ratDjnfbHtU2Fe67t23YOO+QyY/yMn2QtqqGvYxoK3ubI8be90BN1/Q9MGiTxl9fr3jQMU4m/kL',
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                        bddCtrl: bddRef,
                        value: Me.mGetPara(itemData.key),
                        dataDefault: itemData.defaut,
                        allowSup: false,
                        tooltipModif: "Modifier le modele",
                        tooltipSupp: "Supprimer le modele",
                        tooltipNew: "Créer un nouveau modéle",
                        titlePopupEmail: itemData.title,
                        rempliTxtLib: function (contentElement, value) {
                            var txtLib = ""
                            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                            contentElement.html(txtLib)
                        },
                        onValueChanged: function (data64Signature) {
                            Me.mGetPara(itemData.key, data64Signature)
                        }
                    }).dxCtrlEmailData("instance")
                }
            })
            //Autoriser reglement CB sur devis
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_doccpt_devis_autorise_cb_sur_print",
                key_parent: "doccpt_devis",
                title: "Autoriser les règlements CB sur les devis",
                aide: "Si vous avez configuré le règlement CB, ce paramètre permet de définir si l'impression d'un devis affiche le QR code de règlement CB ou pas.",
                defaut: false,
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        //label: "Son application",
                        //labelMode: 'floating',
                        value: Me.mGetPara(itemData.key),
                        onValueChanged: function (e) {
                            //dx.component().option("disabled", true)
                            Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
                        }
                    }).dxCtrlSwitch("instance")
                }
            })
            ////Activation duplicata DEVIS
            //lstCleModuleDefaut.push({
            //    isPara: true,
            //    key: "doccpt_general_doccpt_devis_duplicata_active",
            //    key_parent: "doccpt_devis",
            //    title: "Activer le suivi des impressions de duplicata des devis validée",
            //    aide: "A la demande d'impression d'un devis validée, spécifie si " + parametre.nom + " gère le suivi des impressions via les duplicatas. (La première impression correspond à l’original ; toutes les impressions suivantes sont numérotées et portent la mention précisant qu’il s’agit d’un duplicata du document.).",
            //    defaut: false,
            //    itemTemplate: function (itemData, contentElement) {
            //        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
            //            //label: "Son application",
            //            //labelMode: 'floating',
            //            value: Me.mGetPara(itemData.key),
            //            onValueChanged: function (e) {
            //                //dx.component().option("disabled", true)
            //                Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
            //            }
            //        }).dxCtrlSwitch("instance")
            //    }
            //})

            ////DOCCPT COMMANDE
            //modèle email envoi commandes brouillon
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_modele_email_envoi_doccpt_commande_brouillon",
                key_parent: "doccpt_commande",
                title: "Modèle email envoi commande brouillon",
                aide: "Definir le modèle du mail utilisé pour envoyer vos commandes brouillons.",
                defaut: 'pZVdb9owFIavFyn/wcpFezEMCQXahg+NgqmYWqgg7bQrZBJTvCVxFpv0S/vvO6al3fhqYQgZCMfPef2eYzsiw2HznGDedlGtMp6c0GKJlSZ+pXRaPJnYxXJQpiWH2Y7jlI+/JCKRYqIaphE0PeKiTspzyLFRM0lR0S5WkHPq2hW3fIw+20XbNg15ffaVtDwX3QiVMuSLKKJxwNA4FTMehiI2jah7SXBGBsNuv+ciJw+z/H7PIz0Pq+9XkCSahYonNFUFGiqWxlTxjFVN49NYzOKApg91C89fo/qox+7VFYSObNsZtYjdOu6UnDw5Kp6UW52mZRqm4U25RPCmb2B0CRpQxKSktyyvgzD+IHJZrILowlRFoRboT2kqmapbM4mp9Dm3/gofNHvDDhlg1mv1293euYt+zYRiAU5SHis6DpkWUtOsRm3KaNCoRUxRFNOI1Y/ahxlnd4lI1SG4GisWK/3wjgdqyjLuMzz/mkM85orTEEu/bho01FPB48NGrfDMHIvgAUn1MP/HGlP/522qfcW+CEXq3k25YlWrUQt49jLIhMZIAm0xaQL5seSPDMpXSu6rFgqoojgCEXJjTONMxD/ELM3VCgAEWgyS3pKM039+Puf8cELTWJ/zhumuY49IwRozliKf4x8C7EbZhv7MH8RAG8ukehDrca72f6QC7UP2tEQaQN1YBJVdk/RlAFq2Uhs/pFJqKvRflATCtxYtwgI+76x5ShpKZjWeLvrn/dGw3+oSD2jk95pke1B7/UugvXDXQlm0zaviclmBtilsD4FAazxdDQjIHF173YvuEM6z68FCJ9qNCLTXVa/DvX7oNb/bKkBb68B+y9e09SVqtgdw+JNFjVwaOAvBuU0GAG1r2ZeZfrLNUqC920jLxExv4BVjtZ1Ae28H7uAp0PZoe49cLPc8KsDS9Up3hg27Hhl9I2cruwho246h1XFtwOKh9m1bsL4h9HWhL6IdbkaMTeMP',
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                        bddCtrl: bddRef,
                        value: Me.mGetPara(itemData.key),
                        dataDefault: itemData.defaut,
                        allowSup: false,
                        tooltipModif: "Modifier le modele",
                        tooltipSupp: "Supprimer le modele",
                        tooltipNew: "Créer un nouveau modéle",
                        titlePopupEmail: itemData.title,
                        rempliTxtLib: function (contentElement, value) {
                            var txtLib = ""
                            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                            contentElement.html(txtLib)
                        },
                        onValueChanged: function (data64Signature) {
                            Me.mGetPara(itemData.key, data64Signature)
                        }
                    }).dxCtrlEmailData("instance")
                }
            })
            //modèle email envoi commande validé
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_modele_email_envoi_doccpt_commande_valide",
                key_parent: "doccpt_commande",
                title: "Modèle email envoi commande validée",
                aide: "Definir le modèle du mail utilisé pour envoyer vos commandes validées.",
                defaut: 'rZVbb9owFMefh8R3sPKwPgxDQsst3MbFrZja0EHotKfISdziLYmz2KSXad99Nox2EMqgGopMCCe/8z9/H9shmk57FwjSoQlaZw3sVqvVCqm4tcapXj+r4bKhV/V6pY6x7pGPMYs5uxWdfM7v2cgE5wktAEMHvTgBZb1cBUbD1GtmuQ4+6GVdz+f4rP8JDWwTtLuUM1ivVxrQ6H7u3jCREMdjYYgjnzgpDqjfRg3Sbedz4egKwRRNpqOxZQKjKDHe2LKRZUPx9VpmDReBoDFORAkHgiQRFjQlzXzuncsWkY+Tx7YGlx+n7VjkQVzLUEfXDad/atSqw0aleI6MnmEMK1o+l8/Zc8qBvPALGFxJDSAknOM7UlRBEB6I3BYrZHRpLsJACfTmOOFEtLUFh5h7lGp/hU961vQcTSCxBuPhyLowwY8FE8SHcUIjgd2AKCEtxeq05gT7nVZIBAYRDkn7dHiSUnIfs0ScAI9FgkRCPbynvpiTlHoELm8LgEZUUBxA7kmvcaBelR6fdFqlFdNl/iPg4nH5j+Zi7/tdonyFHgtYYt7PqSBNrdPyafpn4DGOAJe09Uu3Mj/k9InI6TuLH5oa8LHAMJQi+KsxnT6LvrFFUmiVJFDSIinpJYmbbPxc5Tw4YT63O+cNWdAgIE9AyBpTkgCPwm9M2g1S1aFg3aHF95HL4+ZqlLSlxv8jUNL2mDJgiS9ni4RyPnckzQyStk7uBZhzRZVdF8Y+87R1YxCfLvtpmRIHnGidn5fji7EzHQ9GyEa/1pkkbbuk46jW+OoFqmiZCki4z6vy692j+m0j7E0CrydIaZxJmj26HE3ltjabrOsHby1Z0mZZ3POXqvmgVlmVL2n7189R5Uvaht7ecCLPALSeJhP7xlpw4d8GKG1ZD7aZXnyYpUrbble3ialathljNz2VtKO7ao+nqz3koB6w0eX2WgIl8EbYdGQj5wvqZ1bnc9WStmMbyo47AzIPX6Gpc0EdEur4OeI8hDCf+w0=',
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                        bddCtrl: bddRef,
                        value: Me.mGetPara(itemData.key),
                        dataDefault: itemData.defaut,
                        allowSup: false,
                        tooltipModif: "Modifier le modele",
                        tooltipSupp: "Supprimer le modele",
                        tooltipNew: "Créer un nouveau modéle",
                        titlePopupEmail: itemData.title,
                        rempliTxtLib: function (contentElement, value) {
                            var txtLib = ""
                            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                            contentElement.html(txtLib)
                        },
                        onValueChanged: function (data64Signature) {
                            Me.mGetPara(itemData.key, data64Signature)
                        }
                    }).dxCtrlEmailData("instance")
                }
            })
            //Autoriser reglement CB sur commande
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_doccpt_commande_autorise_cb_sur_print",
                key_parent: "doccpt_commande",
                title: "Autoriser les règlements CB sur les commandes",
                aide: "Si vous avez configuré le règlement CB, ce parametre permet de définir si l'impression d'une commandes affiche le QR code de règlement CB ou pas.",
                defaut: false,
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        //label: "Son application",
                        //labelMode: 'floating',
                        value: Me.mGetPara(itemData.key),
                        onValueChanged: function (e) {
                            //dx.component().option("disabled", true)
                            Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
                        }
                    }).dxCtrlSwitch("instance")
                }
            })
            ////Activation duplicata COMMANDE
            //lstCleModuleDefaut.push({
            //    isPara: true,
            //    key: "doccpt_general_doccpt_commande_duplicata_active",
            //    key_parent: "doccpt_commande",
            //    title: "Activer le suivi des impressions de duplicata des commandes validée",
            //    aide: "A la demande d'impression d'une commande validée, spécifie si " + parametre.nom + " gère le suivi des impressions via les duplicatas. (La première impression correspond à l’original ; toutes les impressions suivantes sont numérotées et portent la mention précisant qu’il s’agit d’un duplicata du document.).",
            //    defaut: false,
            //    itemTemplate: function (itemData, contentElement) {
            //        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
            //            //label: "Son application",
            //            //labelMode: 'floating',
            //            value: Me.mGetPara(itemData.key),
            //            onValueChanged: function (e) {
            //                //dx.component().option("disabled", true)
            //                Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
            //            }
            //        }).dxCtrlSwitch("instance")
            //    }
            //})

            ////DOCCPT FACTURE
            //modèle email envoi facture brouillon
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_modele_email_envoi_doccpt_facture_brouillon",
                key_parent: "doccpt_facture",
                title: "Modèle email envoi facture brouillon",
                aide: "Definir le modèle du mail utilisé pour envoyer vos factures brouillon.",
                defaut: 'pZVtb9owEMdfL1K+g5UX64thSOgDNAU0CmnF1IYK0k57hZzEFHdJnMUmfdK++85paTcItHQIOSacf/f33fkcO+Nx99TBrG+jVrPhB839RmPqNxqN/cC0KEwosZrm3t6UhPWvKU8Fn8qOroVdz7HRScYqyDJRN81Q3awfIOvQNpu2uY++mHXT1DVxefzN6Xk2uuIyo2hKAjmHp5/xOYsinuhaPDh3cO6MxoOhayOrCouCoes5rofljwvwEc8jyVKSyRqJJM0SIllOj3Ttk8/nSUiy+7aBi8+kPXHpnbwA04lpWhOzvntgmf3dqtXv9ZwD89DQNV3zZkwg+JJXMDoHDSimQpBrWlVGGL8TuSxWgnVtJuNICQxmJBNUto25wEQEjBl/mY+67vjEGWHq9ob9gXtqo19zLmmI04wlkvgRVUJaitVpzSgJO62YSoISEtP2bn8nZ/Q25ZncQQFPJE2kennLQjmjOQsoLqYVxBImGYmwCNq6RiK1FGK802nVnpg+D++RkPfFP4ZPgp/XmYorDnjEM/t2xiQ9MjqtkOXPg0hJggTQFoum4B8L9kAhfXvp3ZGBQiIJjkGEWGvTOebJDZ9nlVYNgEBLQNKrEz/75+eTz3c71LVyn1dUVR19QBL2mNMMBQzfcAg3ysvLs/o58YEm0iOYwFiI/S+lQHtPdHo8CyFtNIbEljhdDEBbSU0QESEUFcovTkMeGIsKoSErCqtwSSJBjc7j2fB0OBkPewPHc4D2u8TZB6ju8HwCtGduGZTGm2JVX8kq0NaYfUQg0B4vRo6SeekNzgZj6GaXo4VOtCVRVchi1yW4l4fa89ulArTSCHxs++pklaao2x9B63cWubdJaC0EV9YGAGib0r7MDNKNIVVn4Y1CWibm6vyuBLYIp6JtPoHbxBRo25e955xNlmoe1dTWVe/dFjYeeM7ku3O8TGzVio60tg2tjqUGLy+BtslYXRDqtlD30BYXI8a69gc=',
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                        bddCtrl: bddRef,
                        value: Me.mGetPara(itemData.key),
                        dataDefault: itemData.defaut,
                        allowSup: false,
                        tooltipModif: "Modifier le modele",
                        tooltipSupp: "Supprimer le modele",
                        tooltipNew: "Créer un nouveau modéle",
                        titlePopupEmail: itemData.title,
                        rempliTxtLib: function (contentElement, value) {
                            var txtLib = ""
                            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                            contentElement.html(txtLib)
                        },
                        onValueChanged: function (data64Signature) {
                            Me.mGetPara(itemData.key, data64Signature)
                        }
                    }).dxCtrlEmailData("instance")
                }
            })
            //modèle email envoi facture/ticket
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_modele_email_envoi_doccpt_facture_valide",
                key_parent: "doccpt_facture",
                title: "Modèle email envoi facture validée",
                aide: "Definir le modèle du mail utilisé pour envoyer vos factures par mail au client.",
                defaut: 'rZVdU+IwFIavlxn+Q6YX68UaaBEQasFFjA47Ci5Ud/aKCW2Q7LZNtwn1Y8f/vidVUORDdJZhUkiT57znzUkSksGgdUowP7aRUyqbe2WzVKuxWoVaZnVkeuOq5+9XLDaq1Mv1r7GIpRirZj7nt1xio5OE7yLLRK04QSWzVEVW3TZr9t4++mKWTDOfk5dH30jbtVHjkEuBa7VKHVuH3w+vhErYcEw9NYVnSgPuN0idHTbyubBzTnBK+oNOr2sjqwAUr9d1SdfF6ucFBA2ngeIxTVSRBoolEVU8ZQf53KeRmEY+Te4aBs4+w8awy27VBQwdmqY13C+RSrXcahcqdcsqVet7Rj6Xz7kTLhF86TMYnYMGFDIp6TUr6EEYb4l8LVbB6OJEhYEW6E1oIplqGM9eGC8m9FvdwQnpY9Zt94473VMb/ZkKxXwcJzxSdBQwLcXRtKYzYdRvOiFTFEU0ZI29452Us5tYJGoHeSJSLFK684b7asJS7jGc/dxFPOKK0wBLD9ymgZ4KLu80neIjcyT8OyTVXfbGGFHv93WincWeCERi30y4YgdG0/F5+tTImEZIAm02aQzxseT3DBawHN8eGMiniuIQRMi1Y5pHIvolpsmuUwQg0CKQ9BxklCz8fYy5dcB8bnXMKzblQcDukYIcU5Ygj+NfAuxGqS5R9FSihc/RSMYHj60DNC3xP+nb5FvznCUeR/4OTQUHcRPBJUdRJg02jC4KLiULYbELmW0R0BZ0rGoybV5ApdRBoSrD2BeeMSsb5vOs2uAl0IwxDSQzmn/Peqe94aDX7hCXPDjLBrxN1Zk+gefUbu98E5SFa60EGthU2qK8sjFvCNT19jLzucCLPtEaL93OWWcAp95lf6YTrScCbcnLhZRX4OYPnfOCr3qfrimmD6QPtLcXfi62ddyHK4LM1simvjUTvIvm2rYqprVML54hgbbB1e2Jqd7UD0B77e02G3SNp9leeGdVrVbrkrMh0F6VPSp+KPVBxyWa9oMcLW+kDafUcjsfoM+3Vf2bOvWtoa8QfTm9477EOJ/7Bw==',
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                        bddCtrl: bddRef,
                        value: Me.mGetPara(itemData.key),
                        dataDefault: itemData.defaut,
                        allowSup: false,
                        tooltipModif: "Modifier le modele",
                        tooltipSupp: "Supprimer le modele",
                        tooltipNew: "Créer un nouveau modéle",
                        titlePopupEmail: itemData.title,
                        rempliTxtLib: function (contentElement, value) {
                            var txtLib = ""
                            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                            contentElement.html(txtLib)
                        },
                        onValueChanged: function (data64Signature) {
                            Me.mGetPara(itemData.key, data64Signature)
                        }
                    }).dxCtrlEmailData("instance")
                }
            })
            //Autoriser reglement CB sur facture
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_doccpt_facture_autorise_cb_sur_print",
                key_parent: "doccpt_facture",
                title: "Autoriser les règlements CB sur les factures",
                aide: "Si vous avez configuré le règlement CB, ce parametre permet de définir si l'impression d'une facture affiche le QR code de règlement CB (si elle n'est pas soldée).",
                defaut: true,
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        //label: "Son application",
                        //labelMode: 'floating',
                        value: Me.mGetPara(itemData.key),
                        onValueChanged: function (e) {
                            //dx.component().option("disabled", true)
                            Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
                        }
                    }).dxCtrlSwitch("instance")
                }
            })
            ////Activation duplicata FACTURE
            //lstCleModuleDefaut.push({
            //    isPara: true,
            //    key: "doccpt_general_doccpt_facture_duplicata_active",
            //    key_parent: "doccpt_facture",
            //    title: "Activer le suivi des impressions de duplicata des factures validée",
            //    aide: "A la demande d'impression d'une facture validée, spécifie si " + parametre.nom + " gère le suivi des impressions via les duplicatas. (La première impression correspond à l’original ; toutes les impressions suivantes sont numérotées et portent la mention précisant qu’il s’agit d’un duplicata du document.).",
            //    defaut: true,
            //    itemTemplate: function (itemData, contentElement) {
            //        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
            //            //label: "Son application",
            //            //labelMode: 'floating',
            //            value: Me.mGetPara(itemData.key),
            //            onValueChanged: function (e) {
            //                //dx.component().option("disabled", true)
            //                Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
            //            }
            //        }).dxCtrlSwitch("instance")
            //    }
            //})

            ////DOCCPT Ticket
            //modèle email envoi facture brouillon
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_modele_email_envoi_doccpt_ticket_brouillon",
                key_parent: "doccpt_ticket",
                title: "Modèle email envoi récapitulatif (Ticket brouillon)",
                aide: "Definir le modèle du mail utilisé pour envoyer vos récapitulatif (ticket brouillon).",
                defaut: 'rVRdb9owFH1epPwHixcehiEBWiANaLS4FVMJFaSd9oQcxxR3SZzaJv0S/312+jG6rh+TGkVKfHPvOSfn+jpF8/nwCEE28oDfbRMStUg7alHHdVux22n2lnHkuLvLaLnbib/lPJd8qQa2FQ9D5IFDwWqgAyZYgKbT3AFN19vpgK+O6zi2JU/3v6OD0ANnXAkKlpiotaC2lY4nCBZoNh9PAw+4dZ1KpkGIghCqnycaNV0niuVYqAZOFBUZVqyge7b1JeLrLMbipl+B5bXoLwJ6rU506sJx3AVym+3OcBfVOz232+22WxXbsq1wxSTQN/4DDCZaA0iplPic1k0ShB+E/Fus0tmNlUoTI5CssJBU9StMctjt7vSgW9kqmA2D+SGaQRocTEfj4MgDl2uuaAxzwTKFo4QaKb5BG/griuOBn1KFQYZT2m+NqgWjVzkXqgoIzxTNlAlesVit9EtMC0YoLJc1wDKmGO7bVgIlwYkp105XB37jHjfi8Q2Q6qb8Uo0w+XUujLuQ8IQL72rFFN2r6kb7MSseH77McfZUVVlqEVCyW6q72M6v9yqDfZ5d8LWo+Q2Tqcm2ivtD59n6XbAzumZJQm+B0soKKgBh8IJro0BRbijRRz2i/xDnTK0TvUmWdc1R0nwC+4QKwkBcxQVnmnrFmWQgK4k1r2kWk1Kz01T3of4plHfH06PpYj49GKMQbf4F6UvtRXb+FlTzHiqYTl4iPVRr1c9RafoBxJMZMqCn4fh4PNfTfzrbgLutiEYtg09sBvWD//9AMRzN9HGEHoV7OHY3NfA8XNJ4JN+AF+mF2S6v+PYedYiOn/wCDXA3H4do8QPtb5uoqd9s8qtxM2xm8sxc/8dRA6Ft/QY=',
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                        bddCtrl: bddRef,
                        value: Me.mGetPara(itemData.key),
                        dataDefault: itemData.defaut,
                        allowSup: false,
                        tooltipModif: "Modifier le modele",
                        tooltipSupp: "Supprimer le modele",
                        tooltipNew: "Créer un nouveau modéle",
                        titlePopupEmail: itemData.title,
                        rempliTxtLib: function (contentElement, value) {
                            var txtLib = ""
                            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                            contentElement.html(txtLib)
                        },
                        onValueChanged: function (data64Signature) {
                            Me.mGetPara(itemData.key, data64Signature)
                        }
                    }).dxCtrlEmailData("instance")
                }
            })
            //modèle email envoi facture/ticket
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_modele_email_envoi_doccpt_ticket_valide",
                key_parent: "doccpt_ticket",
                title: "Modèle email envoi ticket",
                aide: "Definir le modèle du mail utilisé pour envoyer vos ticket par mail au client.",
                defaut: 'rZRbb5swFMefh8R3sPKSh8UJ0FwaSqIljRsxNaRKaKc9RQ44jVvAzHboTfnus+ll6bpeJhUhgQ/n/P6Hc3ycovl8MEaQjlzgxa1mpx2vLKfVbHVj0rGXlu20O93YcZy2Wn7LWS7YSvZNIx6EyAVHnNZAB0wwB46KAo7ttjpu0wFfLduyTEOcDr+jw9AFZ0xyAlY4khtOTCP1JwgWaDb3p4EL7LpyjaZBiIIQyp8nCpxuEklzzGUDJ5LwDEtakAPT+LJkmyzG/KZXgeW16C0Cci1PlOvCsuzFntVEreGwWx/stUfWaNStmIZphGsqgLrxHzCYqBxASoTA56SunSD8IPLvZKXybqxlmugEozXmgshehQoG9/dbXWhXdgJmg2B+hGaQBIfTkR+MXfBrwySJYc5pJvEyIToVT9P63prguO+lRGKQ4ZT09kbVgpKrnHFZBRHLJMmkNl7RWK7VS0wKGhFYLmuAZlRS3DONBIoIJzpcVbra9xr33CWLb4CQN+WX6hJHl+dcVxdGLGHcvVpTSQ6qqtdeTIvHhydynD1FVVYqCSjoLVFdbObXB5X+kGUXbMNrXkN7KrGd4N7AerZ+F3ZGNjRJyC2QKrOCcBBReMFUoUBRbihJo0ui/lDWFbqkf4LohPCIgriKC0aV4ppRQUFW6vVQV/eICqFESarKX/8Uybvj6Xi6mE8PfRSi7b+QnlAlyM7fQjn3qGA6eUl6iFZZP6eS9APEkxnS0NPQP/bnau5PZ1twt2NR1NL4pKapH/z/B4nBaKYOIvSYuItje1sDz82ljBvlW/DCvdC75JW6vScdouOneoEGuJv7IVr8QMPdIirpN5v8ql3PmB44Pc7/ccJAaBq/AQ==',
                itemTemplate: function (itemData, contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                        bddCtrl: bddRef,
                        value: Me.mGetPara(itemData.key),
                        dataDefault: itemData.defaut,
                        allowSup: false,
                        tooltipModif: "Modifier le modele",
                        tooltipSupp: "Supprimer le modele",
                        tooltipNew: "Créer un nouveau modéle",
                        titlePopupEmail: itemData.title,
                        rempliTxtLib: function (contentElement, value) {
                            var txtLib = ""
                            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                            contentElement.html(txtLib)
                        },
                        onValueChanged: function (data64Signature) {
                            Me.mGetPara(itemData.key, data64Signature)
                        }
                    }).dxCtrlEmailData("instance")
                }
            })
            //Autoriser reglement CB sur ticket
            lstCleModuleDefaut.push({
                isPara: true,
                key: "doccpt_general_doccpt_ticket_autorise_cb_sur_print",
                key_parent: "doccpt_ticket",
                title: "Autoriser les règlements CB sur les tickets",
                aide: "Si vous avez configuré le règlement CB, ce parametre permet de définir si l'impression d'un ticket affiche le QR code de règlement CB (si elle n'est pas soldée).",
                defaut: false,
                itemTemplate: function (itemData, contentElement) {
                    var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                        //label: "Son application",
                        //labelMode: 'floating',
                        value: Me.mGetPara(itemData.key),
                        onValueChanged: function (e) {
                            //dx.component().option("disabled", true)
                            Me.mGetPara(itemData.key, e.value) //, function () { dx.component().option("disabled", false) })
                        }
                    }).dxCtrlSwitch("instance")
                }
            })

            //HEBERGEMENT

            if (bddRef.objCptCli.objetMetier.hasHebergement()) {
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_nb_mois_affiche_avant_today",
                    key_parent: "hebergement_gestion_general",
                    title: "Nombre de mois d'historique affiché dans le planning",
                    aide: "Le planning affiche toutes les réservations actuelles et futures. Pour l'historique, vous pouvez choisir le nombre de mois passés à afficher.",
                    defaut: (bddRef.isDemo ? 60 : 18),
                    itemTemplate: function (itemData, contentElement) {
                        $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlNumberBox({
                            buttonLeftRight: true,
                            width: 200,
                            labelMode: 'floating',
                            label: "Nombre de mois",
                            min: 3,
                            max: 60,
                            value: Me.mGetPara(itemData.key),
                            onValueChanged: function (e) {
                                Me.mGetPara(itemData.key, e.value)
                            }
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_periode_basse_saison",
                    key_parent: "hebergement_gestion_general",
                    title: "Période de basse saison",
                    aide: "Définissez ici les périodes ou votre établissement est en basse saison. Dans ces périodes, c'est le tarif basse saison qui est appliqué (s'il existe, sinon haute saison).",
                    defaut: [[]],
                    itemTemplate: function (itemData, contentElement) {
                        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                        $("<div/>").appendTo($Td).dxCtrlButton({
                            icon: "fas fa-plus",
                            onClick: function (e) {
                                lst.push([])
                                mAddDr(lst[lst.length - 1])
                            }
                        })
                        var $Td = $("<td style='width:100%'>Ajouter une période de basse saison</td>").appendTo($Tr)

                        var lst = Me.mGetPara(itemData.key)
                        lst.forEach(function (item, idx) {
                            mAddDr(item)
                        })

                        function mAddDr(item) {
                            var dxDr = $('<div/>').appendTo(contentElement).dxDropDownBox({
                                value: item,
                                fieldTemplate: function (value, fieldElement) {
                                    var text = (!value || value.length == 0 ? "Définissez une période de basse saison" : "du " + value[0].getDate() + "/" + (value[0].getMonth() + 1) + " au " + value[1].getDate() + "/" + (value[1].getMonth() + 1))
                                    $('<div/>')
                                        .addClass('dx-texteditor-input')  // hérite du style natif du champ
                                        .text(text)
                                        .appendTo(fieldElement);
                                },
                                buttons: [{
                                    focusStateEnabled: false,
                                    name: 'del',
                                    location: 'after',
                                    options: {
                                        icon: 'fas fa-xmark',
                                        hint: "supprimer la période",
                                        onClick() {
                                            lst.splice(lst.indexOf(item), 1)
                                            Me.mGetPara(itemData.key, lst)
                                            dxDr.element().remove()
                                        },
                                    },
                                }],
                                acceptCustomValue: false,
                                showClearButton: true,
                                openOnFieldClick: true,
                                dropDownOptions: {
                                    width: "100%",
                                    container: 'body'
                                },
                                //deferRendering: true, // le contenu de la popup n'est créé qu'à la première ouverture
                                // contentTemplate : element = conteneur jQuery de la popup (équivalent de "contentElement")
                                contentTemplate: function (templateData, element) {
                                    var rangeSelectorInstance = $('<div/>').appendTo(element).dxRangeSelector({
                                        margin: {
                                            top: 50,
                                        },
                                        scale: {
                                            startValue: new Date(2026, 0, 1),
                                            endValue: new Date(2026, 11, 31),
                                            minorTickInterval: 'day',
                                            tickInterval: 'week',
                                            minRange: 'week',
                                            maxRange: 'year',
                                            minorTick: {
                                                visible: false,
                                            },
                                        },
                                        sliderMarker: {
                                            format: 'monthAndDay',
                                        },
                                        value: templateData.component.option('value')
                                    }).dxRangeSelector("instance");
                                    $("<div style='display:inline-block;text-align:right;'/>").appendTo(element).dxCtrlButton({
                                        text: "valider",
                                        onClick: function (e) {
                                            if (rangeSelectorInstance && templateData.component) {
                                                var value = rangeSelectorInstance.option('value');
                                                templateData.component.option('value', value);
                                                templateData.component.close();
                                            }
                                        }
                                    })
                                },
                                // C'est ICI, au niveau du dxDropDownBox, que la valeur validée est traitée.
                                onValueChanged: function (e) {
                                    var idx = lst.indexOf(item)
                                    lst[idx] = e.value
                                    item = e.value
                                    Me.mGetPara(itemData.key, lst)
                                }
                            }).dxDropDownBox("instance")
                        }
                        //$("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlNumberBox({
                        //    buttonLeftRight: true,
                        //    width: 200,
                        //    labelMode: 'floating',
                        //    label: "Nombre de mois",
                        //    min: 3,
                        //    max: 60,
                        //    value: Me.mGetPara(itemData.key),
                        //    onValueChanged: function (e) {
                        //        Me.mGetPara(itemData.key, e.value)
                        //    }
                        //})
                    }
                })
                //gestion réservation
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_période_arrivee_depart",
                    key_parent: "hebergement_gestion_reservation",
                    title: "Période d'arrivé et de départ des hôtes",
                    aide: "Défini une plage horaire pour l'arrivée et le départ des hôtes. Cette information est affichée pour les réservations internet et sur les récapitulatif de réservations.",
                    defaut: { arrivee: [17, 19], depart: [7, 10] },
                    itemTemplate: function (itemData, contentElement) {
                        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:100%;position:relative;'/>").appendTo($Tr)
                        $("<div style='width:100%;font-family:barlow condensed;padding-left:20px;opacity:0.6;position:absolute;'/>").appendTo($Td).text("Plage horaires des arrivées")
                        $("<div/>").appendTo($Td).dxRangeSelector({
                            margin: {
                                top: 14,
                                bottom: 0
                            },
                            size: { height: 80, width: 440 },
                            scale: {
                                startValue: 14,
                                endValue: 23,
                                minorTickInterval: 1,
                                tickInterval: 1,
                                minorTick: {
                                    visible: false,
                                },
                                label: {
                                    customizeText: function (info) {
                                        return info.valueText + 'h';
                                    },
                                },
                            },
                            sliderMarker: {
                                customizeText: function (info) {
                                    return info.value + 'h';
                                },
                            },
                            value: Me.mGetPara(itemData.key).arrivee,
                            onValueChanged: function (e) {
                                var newVal = Me.mGetPara(itemData.key)
                                newVal.arrivee = e.value
                                Me.mGetPara(itemData.key, newVal)
                            }
                        });
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:100%;position:relative;'/>").appendTo($Tr)
                        $("<div style='width:100%;font-family:barlow condensed;padding-left:20px;opacity:0.6;position:absolute;'/>").appendTo($Td).text("Plage horaires des départs")
                        $("<div/>").appendTo($Td).dxRangeSelector({
                            margin: {
                                top: 14,
                                bottom: 0
                            },
                            size: { height: 80, width: 440 },
                            scale: {
                                startValue: 0,
                                endValue: 12,
                                minorTickInterval: 1,
                                tickInterval: 1,
                                minorTick: {
                                    visible: false,
                                },
                                label: {
                                    customizeText: function (info) {
                                        return info.valueText + 'h';
                                    },
                                },
                            },
                            sliderMarker: {
                                customizeText: function (info) {
                                    return info.value + 'h';
                                },
                            },
                            value: Me.mGetPara(itemData.key).depart,
                            onValueChanged: function (e) {
                                var newVal = Me.mGetPara(itemData.key)
                                newVal.depart = e.value
                                Me.mGetPara(itemData.key, newVal)
                            }
                        });
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_heure_arrivee_depart",
                    key_parent: "hebergement_gestion_reservation",
                    title: "Heure d'arrivé et de départ des hôtes",
                    aide: "A la création d'une réservation, définir les heures d'arrivée et de départ qui seront utilisée pour initier la réservation.",
                    defaut: { arrivee: "17", depart: "10" },
                    itemTemplate: function (itemData, contentElement) {
                        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:50%;text-align:right;'/>").appendTo($Tr)
                        $("<div style='display:inline-block;'/>").appendTo($Td).dxCtrlHeureBox({
                            width: 80,
                            labelMode: 'floating',
                            label: "Arrivée",
                            value: Me.mGetPara(itemData.key).arrivee,
                            onValueChanged: function (e) {
                                var newVal = Me.mGetPara(itemData.key)
                                newVal.arrivee = e.value
                                Me.mGetPara(itemData.key, newVal)
                            }
                        })
                        var $Td = $("<td style='width:50%;text-align:left;'/>").appendTo($Tr)
                        $("<div style='display:inline-block;'/>").appendTo($Td).dxCtrlHeureBox({
                            width: 80,
                            labelMode: 'floating',
                            label: "Départ",
                            value: Me.mGetPara(itemData.key).depart,
                            onValueChanged: function (e) {
                                var newVal = Me.mGetPara(itemData.key)
                                newVal.depart = e.value
                                Me.mGetPara(itemData.key, newVal)
                            }
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    key: "hebergement_reservation_service",
                    key_parent: "hebergement_gestion_reservation",
                    title: "Définir les services obligatoires",
                    aide: "A la création d'une réservation, définir les services qui seront automatiquement ajoutés.",
                    defaut: [],
                    itemTemplate: function (itemData, contentElement) {
                        $("<div/>").appendTo(contentElement).dxCtrlLstReservationService({
                            bddCtrl: bddRef,
                            keyPara: itemData.key
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_modele_email_information_reservation_sans_arrhes",
                    key_parent: "hebergement_gestion_reservation",
                    title: "Modèle email envoi récapitulatif pour une réservation",
                    aide: "Definir le modèle du mail utilisé pour envoyer le récapitulatif d'une réservation. Sous votre message sera rajouté le récapitulatif de la réservation. Si la réservation est en attente d'arrhes, cela sera spécifié dans le récapitulatif de la réservation.",
                    defaut: 'nZVdc+I2FIavywz/QeObXBQF2wECDjglwcnQSSAF0k6vGMU+FO3YlleSnWU7/e89MhA+mqTJMozA0tGj97w6spJgOu3fBpQPPNI9N5/motO021HYaZ8Ba7JGowXnbqsFjRB+yUSmxEL71UrUnwUeuZG8Rtrknq2Ia7stYjveWcOzW+Rn27XtakU9Xv0aXM880rvkStB2u9mhzuVvl78LLWEue0FHgSyY5iK97FUryfA+oEUwmQ7HI484p0gIx6NZMJpR/ecDrpfkseYZk7rOYg0yxZkFXFQrPz2JPI2YXPUsWn7mvfkIvukHDJ3btjNvOW5/0L5pnw7sVst1AseqVqqV2ZIrgl+2A5N71EASUIr9BacmiNIPIo/FaoyuL3USG4HhkkkFumc98zQSz4o6btO19qZM+qPpTTChMLoeD4ajW498zYWGiGaSp5o9xWDEdA3P7y6BRX43Ac1IyhLonQ1OCg7PmZD6hIQi1ZBq0/nMI72EgodAy781wlOuOYupCtFvFpup6POJ362vmU8iWhGlV+WItUAUXbCExyuPMIkTa2QJcQGah6xGFEsVxR3kiwuklcGKfwfPaWTfLiy/G/HC72YkYppRpdE4w7StdQekkXlsW/6VSL+IXNa69WwTbrTtZjhHUxzXsfxpzjWQXmCTwhQTOSgmDE8VScsBZOGQcZArBQk6UyMF5DyO4TvRUuQFSBJy+kWgzyRek0KWcZ3HCFuQCDZLKBxAmtF6utO6J/TMPlLacJuWPxK5QgI2EpeXIepTJOp1XFYgTXBcfSm44lu9h2IJaJyntJm0yzbiKhOKl7lmqIdokRvXADd4IWSydiEUSRYjz3AYl/C66oZ7fqS6YdIwe4B9XNGYKU1TEZUlsQnFbpHGq123fy1khAWydrhcqF7u/7pB2u7hpVEZQ5XIV4aBZyTJIhFa2xKGiJeVX5YiixVY/t9349vxHGnT8fUwmAX/dOsGcrDYZ6lIQ/BofD9/BwrJBnx4OMp6J45rCn7tjHmP4Xl7O+xTAs252mT+MAmMxsfZ8G44xdfv42Srk3yYiGdhz8s3cC8/JudjX/fyQtqrDvxY+mYX3tv4/mCCd1Ww3SOPRc5WcO2/Bpjq/f9iOmaG2auWrl37UHkeEwvznjkw1rj2rq2f8hRpP1BVW7Wz4O6g5o1rmHv94wW1B5sOZ8H8j+DqhYi044raZf0kt49vtuYuMheTufI+cQ9TWq38Cw==',
                    itemTemplate: function (itemData, contentElement) {
                        $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                            bddCtrl: bddRef,
                            value: Me.mGetPara(itemData.key),
                            dataDefault: itemData.defaut,
                            allowSup: false,
                            tooltipModif: "Modifier le modele",
                            tooltipSupp: "Supprimer le modele",
                            tooltipNew: "Créer un nouveau modéle",
                            titlePopupEmail: itemData.title,
                            rempliTxtLib: function (contentElement, value) {
                                var txtLib = ""
                                txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                                contentElement.html(txtLib)
                            },
                            onValueChanged: function (data64Signature) {
                                debugger
                                Me.mGetPara(itemData.key, data64Signature)
                            }
                        }).dxCtrlEmailData("instance")
                    }
                })

                if (bddRef.objCptCli.objetMetier.hasSondage()) {
                    lstCleModuleDefaut.push({
                        isPara: true,
                        key: "hebergement_internet_reservation_id_sondage",
                        key_parent: "hebergement_gestion_reservation",
                        title: "Enquête de satisfaction envoyée à vos hôtes à la fin de leur séjour.",
                        aide: "Choisissez l'enquète de satisfaction envoyé par email à vos hôtes. Si vous choisissez une enquête, " + parametre.nom + " enverra un lien à votre hôte (s'il dipose d'un email) pour répondre à l'enquête de satisfaction. ce mail est envoyé chaque nuit aux réservations expirées qui ont été facturées.",
                        defaut: 1,
                        itemTemplate: function (itemData, contentElement) {
                            var lstSondage = JSON.parse(JSON.stringify(bddRef.mGetArray("sondage").filter(function (o) { return o.fini == "0" }))).sort(function (o1, o2) { return (o1.nom).localeCompare(o2.nom) })
                            lstSondage.unshift({
                                id_sondage: 0, nom: "(aucun sondage)"
                            })
                            var dataSondageSelected = lstSondage.filter(function (o) { return o.id_sondage == Me.mGetPara(itemData.key) })[0]
                            $("<div/>").appendTo(contentElement).dxSelectBox({
                                labelMode: "floating",
                                label: "Choisissez un sondage",
                                dataSource: lstSondage,
                                value: dataSondageSelected,
                                displayExpr: "nom",
                                onValueChanged: function (e) {
                                    Me.mGetPara(itemData.key, e.value.id_sondage)
                                }
                            })
                        }
                    })
                    lstCleModuleDefaut.push({
                        isPara: true,
                        key: "hebergement_modele_email_reservation_envoi_sondage",
                        key_parent: "hebergement_gestion_reservation",
                        title: "Modèle email envoi enquête satisfaction",
                        aide: "Definir le modèle du mail utilisé pour envoyer le lien d'enquète de satisfaction..",
                        defaut: 'pZZtU+JIEMdfH1V8hyne+OKIJD5QgICHmLW4UnAB7+peUUPSSF9NZuLMJKt3dd99ewKsiLKre5YFptP9y7+fMibhZNK7Cj28bLF2dMqjRXBcP23yZhTUT5on84Y/DwKIfN6cL+a/pSo1amG75VLcm4YtNslklR2xXnbPjvyjOgvqraDZOmmyX/0j3y+XzN3F72F/2mKdczTKazROm15w/vn8D2U1zHiOZmYyPcuLS9MJm3+rTJ93yqVkcBN6eTieDEbDFgsOiRWNhtNwOPXsX7f05CQTFlOubY0LC1pyizmclUu/zFUmY66fOhWv+Jl1ZkN4tLfkOvP9YNboXxyfNMLjw0/9fv3Yb9Qr5VK5NF2iYfTLn8HshjSwBIzh93DonDzvnchdsZa8a0ubCCcwWnJtwHYqzxWpbAWMe8PJp3DswbA/uhwMr1rsIVMWYi/VKC2fC3BS2o7WbS+Bx912ApYzyRPoHF8e5AhfUqXtAYuUtCCtM37B2C4hxwi84s8qQ4kWufBMRNXmwoVSlQ+67dqKOVfxEzP2qbhTWRDKW/AExVOLcU2BVbYEkYPFiFeZ4dJ4BjQuzohWOBv8B1rBSfp4Vum2Y8y77ZRFghvjcGgmICCirEIZV7oXSrq+V9u1dMeNaC88O32fCc5MhhZYDKwYHLYZHBaTDiYLG5lcsdAYSKgIVTJnRDMUklGnZY5WkXMn9Jkm31TJuIjy1/EgH7JO2Fs9xtB0mQWPLCpJd0ghPjgal5a0aCaACST7Au8z7YyOQzoXKF14BJaBl3AUh69TXOdHtFWKxWowtxoMjGWpUxchZI+HbCBcFoaloKnlLD7gCd0UqDTootsoMxCCEiYaqSAFDxkXaMnL6ZDKMOqSGwOCW2dKHHm7ApwuuXVzQz7rGKJFLj9r9utfiR86eUWFNanQEboak85cISlcKjToaG+2yCkCk5JVu6hVDFU2FZzC9KrdROZRlAEKQSYqM9FcUXLgGdVK0XKhLHDvkqqpxJsxcLNENGo4mlQZLJqdurGyKqM5QLlQOuGFOVJJKkipexBHDeuHdftKx7Qcq5FrE82Za8X47/0wKZfPKimBJI1VVNmsL8RYbD3Bik3kwkCl++/16Go0m4z6g3Aa/teuOciLJ/2A6hLdgLeow9HN96CQrMEvXwxuTd26s+DI7TutoeVeQu+aHbctn+8JLIZ3O/Mtgbfj0Gm8mw6uBxM6gu7GG51sD5For2u5k/IbuG9fLufnEhDtzQr8XPrFYv2w8Vtie5djOq/DTY9aPA42gqvsm7b/x4zSAlm83vZW9UPEHAXRBLyq7c64vr+m6134yFTtVTslWni9O/as9lOpTwZEm4azP8OL14v0Kuu53lzu+3SvEHcUu3PZnfgf+CfE88qlrw==',
                        itemTemplate: function (itemData, contentElement) {
                            $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                                bddCtrl: bddRef,
                                value: Me.mGetPara(itemData.key),
                                dataDefault: itemData.defaut,
                                allowSup: false,
                                tooltipModif: "Modifier le modele",
                                tooltipSupp: "Supprimer le modele",
                                tooltipNew: "Créer un nouveau modéle",
                                titlePopupEmail: itemData.title,
                                rempliTxtLib: function (contentElement, value) {
                                    var txtLib = ""
                                    txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                                    contentElement.html(txtLib)
                                },
                                onValueChanged: function (data64Signature) {
                                    debugger
                                    Me.mGetPara(itemData.key, data64Signature)
                                }
                            }).dxCtrlEmailData("instance")
                        }
                    })
                }
                //gestion reservation internet
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_adresse_web",
                    key_parent: "hebergement_resa_internet",
                    title: "Adresse web public pour les réservations",
                    aide: "Lien web pour permettre à vos hôtes de réserver un ou plusieurs hébergement dans votre établissement.",
                    defaut: 0,
                    itemTemplate: function (itemData, contentElement) {
                        var url = parametre.url_appli.replace("app.", "appgo.") + "/" + bddRef.nom_base + "/0/reservation"
                        $("<a href='" + url + "' target='_blank'>" + url + "</a>").appendTo(contentElement)
                        $("<span style='margin-left:10px;'><i class='fas fa-copy state-hover' style='border-radius:50%;padding:5px;' title='Copier le lien dans le presse papier'></i></span>").appendTo(contentElement).on("click", function () {
                            var $temp = $("<input>");
                            $("body").append($temp);
                            $temp.val(url).select();
                            document.execCommand("copy");
                            $temp.remove();
                            mNotify("Le lien de réservation a été copié dans le presse-papier", "success", 6000)
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_resa_internet_list_image_arriere_plan",
                    key_parent: "hebergement_resa_internet",
                    title: "Images de fond pour l'écran de réservation internet",
                    aide: "Parmi les images sélectionnées, " + parametre.nom + " choisira une image au hasard en fond d'écran pour chaque étape de réservation.",
                    defaut: '[]',
                    itemTemplate: function (itemData, contentElement) {
                        mRempli()
                        function mRempli() {
                            contentElement.empty()
                            var tab = JSON.parse(Me.mGetPara(itemData.key))
                            tab.forEach(function (urlImg) {
                                var $TableImage = $("<table style='width:100%;margin:8px 0;'/>").appendTo(contentElement)
                                var $TrImg = $("<tr/>").appendTo($TableImage)
                                var $TdImg = $("<td style='width:100%;'/>").appendTo($TrImg)
                                var dxTextBoxLink = $("<div/>").appendTo($TdImg).dxCtrlTextBox({
                                    bddCtrl: bddRef,
                                    labelMode: "floating",
                                    label: "Lien sur une image pour illustrer la page",
                                    value: urlImg,
                                    readOnly: true
                                }).dxCtrlTextBox("instance")
                                var $TdImg = $("<td style='width:1px;'/>").appendTo($TrImg)
                                $("<div/>").appendTo($TdImg).dxCtrlButton({
                                    icon: "fas fa-delete-left fa-rotate-180",
                                    hint: "Supprimer l'image",
                                    onClick: function (e) {
                                        var tab = JSON.parse(Me.mGetPara(itemData.key))
                                        tab.splice(tab.indexOf(urlImg), 1)
                                        Me.mGetPara(itemData.key, JSON.stringify(tab))
                                        $TableImage.remove()
                                    }
                                })
                            })
                            var $TableImage = $("<table style='width:100%;margin:8px 0;'/>").appendTo(contentElement)
                            var $TrImg = $("<tr/>").appendTo($TableImage)
                            var $TdImg = $("<td style='width:100%;'/>").appendTo($TrImg)
                            var dxTextBoxLink = $("<div/>").appendTo($TdImg).dxCtrlTextBox({
                                bddCtrl: bddRef,
                                labelMode: "floating",
                                label: "Lien sur une image pour illustrer la page",
                                value: page.link_img,
                                onValueChanged: function (e) {
                                    var lien = ((e.value == null) ? "" : e.value)
                                    if (!lien.startsWith("http://") && !lien.startsWith("https://") && !lien.startsWith("ftp://") && !lien.startsWith("ftps://")) {
                                        lien = "http://" + lien
                                    }
                                    var tab = JSON.parse(Me.mGetPara(itemData.key))
                                    tab.push(lien)
                                    Me.mGetPara(itemData.key, JSON.stringify(tab))
                                    mRempli()
                                }
                            }).dxCtrlTextBox("instance")
                            var $TdImg = $("<td style='width:1px;'/>").appendTo($TrImg)
                            $("<div/>").appendTo($TdImg).dxCtrlButton({
                                icon: "fas fa-boxes",
                                hint: "Choisissez un fichier dans votre box<br/>(Vous pouvez choisir un fichier image dans votre box publique. si le fichier est sur votre machine, il vous suffit de le déposer dans le répertoire public de votre box, puis de le sélectionner)",
                                onClick: function (e) {
                                    var pop = $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                                        bddCtrl: bddRef,
                                        machine: false,
                                        box: true,
                                        icone: false,
                                        imgInternet: false,
                                        docCpt: false,
                                        courrier: false,
                                        multiple: false,
                                        optionBox: {
                                            allowRepertoirePublic: true,
                                            allowRepertoirePartage: false,
                                            allowRepertoireUti: false
                                        },
                                        onValide: function (lstUrlFile) {
                                            if (lstUrlFile.length > 0) {
                                                var fic = new cFichier(bddRef, lstUrlFile[0])
                                                var url = fic.urlPublicAbsolue()
                                                if (url.length > 0) {
                                                    dxTextBoxLink.option("value", url)
                                                }
                                            }
                                            pop.hide();
                                        }
                                    }).dxCtrlFileUploaderPopup("instance")
                                }
                            })
                        }
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_temps_seconde_avant_suppression_resa_internet",
                    key_parent: "hebergement_resa_internet",
                    title: "Délai de mise à la corbeille des réservations internet non payées",
                    aide: "Définissez le délai, en minutes, après lequel une réservation en ligne non payée est automatiquement mise à la corbeille en cas d’inactivité. Si un internaute ne valide pas sa réservation, celle-ci sera supprimée après le délai que vous avez défini.",
                    defaut: 10,
                    itemTemplate: function (itemData, contentElement) {
                        $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlNumberBox({
                            buttonLeftRight: true,
                            width: 300,
                            labelMode: 'floating',
                            label: "Temps écoulé en minute",
                            min: 5,
                            max: 100,
                            value: Me.mGetPara(itemData.key),
                            onValueChanged: function (e) {
                                Me.mGetPara(itemData.key, e.value)
                            }
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_taux_occupation_minimale_internet",
                    key_parent: "hebergement_resa_internet",
                    title: "Taux occupation minimum d'un hébergement",
                    aide: "Définissez le taux d’occupation minimal à partir duquel un hébergement peut être proposé à la location. Par exemple, si une personne recherche un hébergement pour une seule personne et que vous avez défini un taux d’occupation minimal de 50 %, seuls les hébergements ayant une capacité d’au moins deux personnes lui seront proposés.",
                    defaut: 50,
                    itemTemplate: function (itemData, contentElement) {
                        $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlNumberBox({
                            buttonLeftRight: true,
                            width: 300,
                            labelMode: 'floating',
                            label: "Taux occupation",
                            min: 0,
                            max: 100,
                            value: Me.mGetPara(itemData.key),
                            onValueChanged: function (e) {
                                Me.mGetPara(itemData.key, e.value)
                            }
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_internet_nb_hebergement_max_propose",
                    key_parent: "hebergement_resa_internet",
                    title: "Nombre d'hébergement proposé à la location",
                    aide: "Lorsque l’internaute sélectionne une date ainsi qu’un nombre de personnes à héberger, une liste des hébergements disponibles lui est proposée, triée par taux d’occupation (du plus élevé au plus faible). Vous pouvez définir ici le nombre maximum d’hébergements à afficher. Si vous indiquez « 1 », seul l’hébergement présentant le meilleur taux d’occupation sera proposé.",
                    defaut: 2,
                    itemTemplate: function (itemData, contentElement) {
                        $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlNumberBox({
                            buttonLeftRight: true,
                            width: 300,
                            labelMode: 'floating',
                            label: "Nombre hébergement proposé",
                            min: 1,
                            max: 200,
                            value: Me.mGetPara(itemData.key),
                            onValueChanged: function (e) {
                                Me.mGetPara(itemData.key, e.value)
                            }
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    key: "hebergement_reservation_service_sur_internet_obligatoire",
                    key_parent: "hebergement_resa_internet",
                    title: "Définir les services obligatoires",
                    aide: "Lors de la création d’une réservation en ligne, définir les services qui seront automatiquement ajoutés à la chambre. Ces services ne pourront pas être supprimés par l’internaute. Ils seront appliqués à chaque nuitée et calculés selon le type de quantité défini.",
                    defaut: [],
                    itemTemplate: function (itemData, contentElement) {
                        $("<div/>").appendTo(contentElement).dxCtrlLstReservationService({
                            bddCtrl: bddRef,
                            keyPara: itemData.key,
                            isForInternet: true,
                            isObligatoire: true
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    key: "hebergement_reservation_service_sur_internet_optionel",
                    key_parent: "hebergement_resa_internet",
                    title: "Définir les services optionnels",
                    aide: "Lors de la création d’une réservation, définir les services proposés à la sélection de l’internaute. Ces services sont affichés conformément à la configuration définie et peuvent être sélectionnés ou non par l’internaute. Ils seront appliqués sur toute les nuitées ou celle sélectionnées par l’internaute.",
                    defaut: [],
                    itemTemplate: function (itemData, contentElement) {
                        $("<div/>").appendTo(contentElement).dxCtrlLstReservationService({
                            bddCtrl: bddRef,
                            keyPara: itemData.key,
                            isForInternet: true,
                            isObligatoire: false
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_internet_champ_saisie_client_obligatoire",
                    key_parent: "hebergement_resa_internet",
                    title: "Définissez les champs à saisir obligatoirement par l'hôte",
                    aide: "Cochez les champs qui doivent obligatoirement être rempli par votre hôte pour valider une réservation. L'adresse email est obligatoire par défaut.",
                    defaut: ["nom", "prenom", "tel"],
                    itemTemplate: function (itemData, contentElement) {
                        var dxChkNom = $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlSwitch({
                            text: "Nom de votre hôte",
                            value: Me.mGetPara(itemData.key).contains("nom"),
                            onValueChanged: function (e) {
                                mSave()
                            }
                        }).dxCtrlSwitch("instance")
                        var dxChkPrenom = $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlSwitch({
                            text: "Prénom de votre hôte",
                            value: Me.mGetPara(itemData.key).contains("prenom"),
                            onValueChanged: function (e) {
                                mSave()
                            }
                        }).dxCtrlSwitch("instance")
                        var dxChkAdr = $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlSwitch({
                            text: "Détail de l'adresse (voie, rue...)",
                            value: Me.mGetPara(itemData.key).contains("adr"),
                            onValueChanged: function (e) {
                                mSave()
                            }
                        }).dxCtrlSwitch("instance")
                        var dxChkCp = $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlSwitch({
                            text: "Code postal",
                            value: Me.mGetPara(itemData.key).contains("cp"),
                            onValueChanged: function (e) {
                                mSave()
                            }
                        }).dxCtrlSwitch("instance")
                        var dxChkVille = $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlSwitch({
                            text: "Ville",
                            value: Me.mGetPara(itemData.key).contains("ville"),
                            onValueChanged: function (e) {
                                mSave()
                            }
                        }).dxCtrlSwitch("instance")
                        var dxChkPays = $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlSwitch({
                            text: "Pays",
                            value: Me.mGetPara(itemData.key).contains("Pays"),
                            onValueChanged: function (e) {
                                mSave()
                            }
                        }).dxCtrlSwitch("instance")
                        var dxChkTel = $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlSwitch({
                            text: "Téléphone de votre hôte",
                            value: Me.mGetPara(itemData.key).contains("tel"),
                            onValueChanged: function (e) {
                                mSave()
                            }
                        }).dxCtrlSwitch("instance")

                        function mSave() {
                            var lst = []
                            if (dxChkNom.option("value")) lst.push("nom")
                            if (dxChkPrenom.option("value")) lst.push("prenom")
                            if (dxChkAdr.option("value")) lst.push("adr")
                            if (dxChkCp.option("value")) lst.push("cp")
                            if (dxChkVille.option("value")) lst.push("ville")
                            if (dxChkPays.option("value")) lst.push("pays")
                            if (dxChkTel.option("value")) lst.push("tel")
                            Me.mGetPara(itemData.key, lst)
                        }
                    }
                })
                //lstCleModuleDefaut.push({
                //    isPara: true,
                //    key: "reservation_internet_data_url_base64_image_fond",
                //    key_parent: "hebergement_resa_internet",
                //    title: "Image d'arrière plan réservation",
                //    aide: "Quand l'écran de choix de chambre s'affiche, la saisie se fait sur un fond blanc ou noir. Vous pouvez choisir une image qui sera affiché en fond.",
                //    defaut: "",
                //    itemTemplate: function (itemData, contentElement) {
                //        mRempli()
                //        function mRempli() {
                //            contentElement.empty()
                //            if (Me.mGetPara(itemData.key).length == 0) {
                //                var $A = $("<a href='javascript:void(0)'>Choisir une image</a>").appendTo(contentElement)
                //                $A.on("click", function () { mDisplayResa() })
                //            } else {
                //                var dataImg = Me.mGetPara(itemData.key)
                //                var opacity = dataImg.split("|")[0]
                //                dataImg = dataImg.split("|")[1]
                //                var fichier = new cFichier(bddRef, dataImg)
                //                var $DivImg = $("<div style='width:100%;max-width:200px;opacity:" + (opacity / 100) + ";'/>").appendTo(contentElement)
                //                var $elementImage = fichier.mGetElementImage($DivImg.outerWidth() - 3, $DivImg.outerWidth() - 3, false).appendTo($DivImg)
                //                //$elementImage.css({ "border-radius": ((typeof option.borderRadius == 'undefined') ? "0" : option.borderRadius + "px") })
                //                if (!fichier.mIsImage()) $elementImage.css({ "width": "100%", "max-width": "", "height": "100%", "font-size": ($DivImg.innerWidth() * 2 / 3) + "px", "display": "flex", "align-items": "center", "justify-content": "center" })
                //                $elementImage.addClass("state-hover")
                //                $elementImage.on("click", function () { mDisplayResa() })
                //                var $A = $("<a href='javascript:void(0)'>Modifier image et opacité</a>").appendTo(contentElement)
                //                $A.on("click", function () { mDisplayResa() })
                //            }

                //            function mDisplayResa() {
                //                popupFullScreen = $("<div/>").appendTo("body").dxCtrlPopupBase({
                //                    fullScreen: true,
                //                    showTitle: false,
                //                    contentTemplate: function (contentElement) {
                //                        contentElement.css("padding", "0")
                //                        $("<div/>").appendTo(contentElement).dxCtrlPageReservationExterneInternet({
                //                            bddCtrl: bddRef,
                //                            isPreview: true,
                //                            onChangeImageFond: function () {
                //                                mRempli()
                //                            },
                //                            onClose: function () {
                //                                popupFullScreen.hide()
                //                                mRempli()
                //                            }
                //                        })
                //                    }
                //                }).dxCtrlPopupBase("instance")
                //                popupFullScreen.show()
                //            }
                //        }

                //    }
                //})
                //gestion arrhes
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_politique_arrhes",
                    key_parent: "hebergement_arrhes",
                    title: "Politique de remboursement des arrhes",
                    aide: "Saisissez les conditions de remboursement des arrhes. Cette information est affiché dans les emails de demande de versement d'arrhes ou sur la page de paiement des arrhes.",
                    defaut: "Toute réservation est confirmée par le versement d’arrhes. En cas d’annulation par le client, ces arrhes restent acquises et ne pourront donner lieu à aucun remboursement, quel qu’en soit le motif.",
                    itemTemplate: function (itemData, contentElement) {
                        $("<div style='display:inline-block;' class='barlow'/>").appendTo(contentElement).dxTextArea({
                            buttonLeftRight: true,
                            width: "100%",
                            labelMode: 'floating',
                            label: "Politique de gestion des arrhes",
                            min: 0,
                            max: 100,
                            value: Me.mGetPara(itemData.key),
                            onValueChanged: function (e) {
                                Me.mGetPara(itemData.key, e.value)
                            }
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_percent_arrhes",
                    key_parent: "hebergement_arrhes",
                    title: "Pourcentage des arrhes",
                    aide: "Définissez le pourcentage d’arrhes demandé pour une réservation. Si vous indiquez 0, aucun arrhes ne sera demandé (sauf sur internet ou les arrhes demandés seront la totalité de la réservation).",
                    defaut: 50,
                    itemTemplate: function (itemData, contentElement) {
                        $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlNumberBox({
                            buttonLeftRight: true,
                            width: 300,
                            labelMode: 'floating',
                            label: "Pourcentage des arrhes",
                            min: 0,
                            max: 100,
                            value: Me.mGetPara(itemData.key),
                            onValueChanged: function (e) {
                                Me.mGetPara(itemData.key, e.value)
                            }
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_mode_reglement_arrhes",
                    key_parent: "hebergement_arrhes",
                    title: "Mode de règlement proposé pour les arrhes",
                    aide: "Définissez ici les modes de règlement des arrhes proposés à vos hôtes. Pour chaque mode de paiement sélectionné, des instructions seront affichées dans le récapitulatif afin d’expliquer comment effectuer le règlement. Ces modes de règlement seront ceux qui seront aussi proposé sur internet.",
                    defaut: [1, 2],
                    itemTemplate: function (itemData, contentElement) {
                        var ds = JSON.parse(JSON.stringify(bddRef.getObjet("mode_reglement").objetMetier.mGetLstDataModeReglementDispo().filter(function (o) { return o.id_mode_reglement == 1 || o.id_mode_reglement == 2 || o.id_mode_reglement == 3 || o.id_mode_reglement == 5 })))
                        $("<div class='barlow'/>").appendTo(contentElement).dxTagBox({
                            labelMode: 'floating',
                            label: "Mode règlement",
                            dataSource: ds,
                            value: Me.mGetPara(itemData.key),
                            valueExpr: "id_mode_reglement",
                            displayExpr: "nom",
                            showDropDownButton: false,
                            onValueChanged: function (e) {
                                var lst = []
                                e.value.forEach(function (id) {
                                    lst.push(id)
                                })
                                Me.mGetPara(itemData.key, lst)
                            }
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_temps_attente_arrhes",
                    key_parent: "hebergement_arrhes",
                    title: "Temps d'attente avant expiration des arrhes",
                    aide: "Définissez le délai d’attente, en jours, avant l’expiration d'une demande d’arrhes à un hôte. Une fois ce délai dépassé, vous serez informé que l’attente a expiré. L’attente est initiée uniquement après l’envoi d’un email de demande d’arrhes. Si vous indiquez 0, l’attente n’expire jamais.",
                    defaut: 0,
                    itemTemplate: function (itemData, contentElement) {
                        $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlNumberBox({
                            buttonLeftRight: true,
                            width: 350,
                            labelMode: 'floating',
                            label: "Temps attente jours règlement des arrhes",
                            min: 0,
                            max: 60,
                            value: Me.mGetPara(itemData.key),
                            onValueChanged: function (e) {
                                Me.mGetPara(itemData.key, e.value)
                            }
                        })
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_expiration_temps_attente_arrhes_annule_reservation",
                    key_parent: "hebergement_arrhes",
                    title: "Annulation de la réservation à expiration des arrhes",
                    aide: "Définissez si une réservation doit automatiquement passer au statut « annulée » lorsque le délai d’attente des arrhes expire. Cette action libère automatiquement le créneau de réservation tout en conservant la réservation affichée dans votre planning. La vérification est effectuée chaque nuit et vous serez informé par email lorsqu’une réservation aura été annulée. Votre hôte sera aussi informé par mail de cette annulation.",
                    defaut: false,
                    itemTemplate: function (itemData, contentElement) {
                        var dx = $("<div/>").appendTo(contentElement).dxCtrlSwitch({
                            value: Me.mGetPara(itemData.key),
                            onValueChanged: function (e) {
                                Me.mGetPara(itemData.key, e.value)
                            }
                        }).dxCtrlSwitch("instance")
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_modele_email_information_reservation_avec_attente_arrhes",
                    key_parent: "hebergement_arrhes",
                    title: "Modèle email envoi pour une réservation en attente d'arrhes",
                    aide: "Definir le modèle du mail utilisé pour envoyer le récapitulatif d'une réservation qui est en attente d'arrhes. Sous votre message sera rajouté le récapitulatif de la réservation qui annonce l'attente du règlement des arrhes pour confirmation.",
                    defaut: 'nZZdb+I4FIavF4n/YOWmF4tLEkKBFNKlNK0YtdAFOqu9QiYxg0dJnLGdtMxq//seh6+BwgxdhALYPo/fc87rhNgfj7sPPmZ3LmqToGY3GtSez67CWc0JbNsOnEbdseatVoOa9h8pTyWfK69cCrsT30X3glVQEz2RJbJN+wqZlltzXKeGfjdt0yyX5MvtJ783cVHnhkmOm816C1s3f9585krQqej4LUlFThTjybTjm9OAJ3MmYipuOuVS3H/yce6Pxv3hwEXWJfCC4WDiDyZY/f0Mu8dZpFhKhKqSSFGRACen1+XSbzOeJSERy46Bi9e0Mx3QN/UMS6emaU2dZrNl3Vq9y3uzbjnN3pVRLpVLkwWTCN5kB0ZPoAHFVEryhV7qRRifiTwUq2B1daHiSAsMFkRIqjrGK0tC/iqxZddt44eQUXcwvvdHmA56w7v+4MFF3zKuaIhTwRJFZhHVYtqa57UXlIReO6aKoITEtFO7u8gZfU25UBcISqpoovTgKwvVguYsoLj4WkEsYYqRCMsA6k0iHQp1vvDa1RVzxsMlkmpZzBhzQOE5iVm0dBEREFhBCxrlVLGAVJAkicTQTza/BlqxWLLv1LWc9O3a8Nohy712ikKiCJYKCqeZprEaoEmofzYN75YnX3kmKu1qul6ute0irIMQy7YMb5wxRRFYCOXaWmjPWrA8kSgpJoAFU7qCTEoaQ2UqKKcZiyL6HSnBs5wKFDD8lUOdUbQiBSRlKosANkchXW8hYQJoWuvlTuuPQu3avlK7Bel15yzRkK3Vt4oLZVvRFRCcSZiEiwChIoBBqSNnjCZ6POJMFPK+REABqTGUnIDqkEqdJxFiQWWl2ImLGBbqdBHJ3vRQyFQBBAOybxlMQlBRpyM5a3cwDFgJao4nWzMP2uLYdcMbHE1BZ9qySa71BwvOJNs0Z78ziCqIk0oH7VobMplyWahHKRQfaEjxDNrPijxXLQ94nEbrlAkT9Lhqx24cqAaas8mESRwRqXDCw8L/u2GeRMvdsNfjIoTTsLJTsVG1MLvOtPg8cpEpAZXAl5oBN4Q4DXlgbM4rhf7oY16cOxJJanj/AO1x+DCcjoe9vj/x/21XNWS72Qep+oyuwYPh08+gNF6D9+8ExeFGlq1Pt/ZbUZwYbi6nl50rEGh7mT+PfK3xZdJ/7I/hyfMy2uhEZxCB9q6WJ3DbD53zYV1XeYF5j1bgf6Wvj+mvG9+9G8Fj2t/0yCWhtRFc2SvASttZZjpkBulhSYH2IXseEnN9U90WFmgn7PoTV52sKdA+7qo9tRP/cet5oG1yr55jqHewcX/iT//ybwsi0PYO0rusZ2Lz8+RVP3j1U1jFugveB/53YFwu/Qc=',
                    itemTemplate: function (itemData, contentElement) {
                        $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                            bddCtrl: bddRef,
                            value: Me.mGetPara(itemData.key),
                            dataDefault: itemData.defaut,
                            allowSup: false,
                            tooltipModif: "Modifier le modele",
                            tooltipSupp: "Supprimer le modele",
                            tooltipNew: "Créer un nouveau modéle",
                            titlePopupEmail: itemData.title,
                            rempliTxtLib: function (contentElement, value) {
                                var txtLib = ""
                                txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                                contentElement.html(txtLib)
                            },
                            onValueChanged: function (data64Signature) {
                                debugger
                                Me.mGetPara(itemData.key, data64Signature)
                            }
                        }).dxCtrlEmailData("instance")
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_modele_email_information_reservation_confirm_reglement_arrhes",
                    key_parent: "hebergement_arrhes",
                    title: "Modèle email envoi pour confirmation de règlement des arrhes",
                    aide: "Definir le modèle du mail utilisé pour envoyer la confirmation de réception du règlement des arrhes. Ce modèle est aussi utilisé pour confirmer le reglèment des arrhes par CB internet.",
                    defaut: 'lZVdc+I2FIavywz/QeObXBQH23w74DQfboZOAik47fSKEdZhUce2vJJwlt3pf++RgSUfsFkYxglCevSeV+9BaTidXt2FNr/1SX/e63Y7juP0HLdH2+DEjQ5dtFin0aKtDm23fstFrsRCB9UKu4pCn0TLVY24TfJA18RzvDZxG77j+c0u+dXxHKdaUU/Xf4Q3kU8Gl1wJu9tt9Wz38s/Lv4SWMJODsKdAFlRzkc1A6VkssgWXKY7D5aBaSYcPoV2Ek+lwPPKJe47EeDyKwlFk638eUUC6SjTPqdR1mmiQGZIKuKhWfpmLVcaoXA8su3zNBrMRfNGPOHXmOO6s2fI6rtd2z8N212n0mj2rWqlWoiVXBN90DyYPqIGkoBT9BOdmkm3/JPKtWI2z60udJkZgvKRSgR5Yzzxj4lnZrtfyrBdLJlej6e/hxIbRzfh2OLrzyeeV0MDsXPJM03kCRkzf8IL+EigL+iloSjKawqBxe1ZweM6F1GcETdWQaTP4zJleQsFjsMt/a4RnXHOa2CpGv2lilqLPZ0G/vmHOBVsTpdflN9YCUfaCpjxZ+4RKXFgjS0gK0DymNaJopmw8Ub64QFo5WfGv4LvN/MuFFfQZL4J+ThjV1FYajTNMx9oMQMbMx64VXIvsX7GStX4930432vYr3DdLXM+1gpFY4cEVIlNkziEjEgZhZ0USIBiz7qcEUvSAMCCFQBpOlXIJiuS4EQ5hHMmrOJ7vN3+5s9d4vbXX6yLNCspAE4UEo5xglklKufGd4q77WBPQJCuVavyOGbWbzQvIVoD6kQYx4WmOKiCL4aCMhvPGgabX2jpQmIfEYmWMVZSVskHPQ2O4JPFScMVRgNkR1ZgYcaU21qAyibqNpEHobGUxrnKhuHGE5EgzxWmx0oDBWQiZll5hfWmeIM9wKJdw2Lym13mhulopx5q7SriyE6q0nQlWRm0/LLJkvR8OboRkGLxS9CYidUMz0WLHHiqnqBL5yjCw99KcidjatQYwXnZUGXGaGNfACr7dj+/Gs+n4ZhhG4X/9uoGYzU6kmhPdgkvqaPzwIyikW/Drpiv7iLge0kwvbcxJsY8PT9v024cCjW8vKy8FPk5Co/EpGt4Pp/g7/zTZ6SQ/JiLtnZffSz6A+/7H1PzWV4W0o6WdXP4mbR8dfCn26naCl2K4OyOfMncnuLYxAGk/H6aDzDjfW2rSdlI8DxILniSA0C0tOBbX434d8tR0/Ompeq82Cu9RKdJexZ7UPwjUYdh0GIWzv0OkXb9vpHdVz+Xu49GnueOQZu48c5uecMXbdrXyPw==',
                    itemTemplate: function (itemData, contentElement) {
                        $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                            bddCtrl: bddRef,
                            value: Me.mGetPara(itemData.key),
                            dataDefault: itemData.defaut,
                            allowSup: false,
                            tooltipModif: "Modifier le modele",
                            tooltipSupp: "Supprimer le modele",
                            tooltipNew: "Créer un nouveau modéle",
                            titlePopupEmail: itemData.title,
                            rempliTxtLib: function (contentElement, value) {
                                var txtLib = ""
                                txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                                contentElement.html(txtLib)
                            },
                            onValueChanged: function (data64Signature) {
                                debugger
                                Me.mGetPara(itemData.key, data64Signature)
                            }
                        }).dxCtrlEmailData("instance")
                    }
                })
                lstCleModuleDefaut.push({
                    isPara: true,
                    key: "hebergement_modele_email_information_reservation_annulation_reservation",
                    key_parent: "hebergement_arrhes",
                    title: "Modèle email envoi pour annulation réservation",
                    aide: "Definir le modèle du mail utilisé pour envoyer l'annonce d'annulation d'une réservation.",
                    defaut: 'nZVfc6pGGMav64zfYYebXFQiEE2UADnRbDN2Ek2FtNMrZoH1uGdgoexCjqfT7953URv/JOfEOoIIu7993ud9gAz7/u091tmdjRyyiHtXl8SI+70oigZmRIe9K2sQJSQ2e4uk/6nIC5EvpNduJbcBtlGwrDrI7KFHskKWYV0i88I2+vbFBfrZsAyj3RLPo1/xOLCRe8NErg8G/aFu3vx283suSxqWLh4KWtZEspyHLjZgG0rYQsJ5lcIBvXHbrWzyiPUaz/3JbGoj8xy48Wwa4Gmgyz+fQEZWpZIVpJRdkkpacuDV9Lrd+inKK56QcuVqevMJ3XBKv8onGBoahhn2r+BjjS/PLTwYWKNRX2u32q1gyQSCL3kFo0fQgDIqBPlMz9UgXf8g8lCshNHdpcxSJTBeklJQ6WovjCf5i9BNq29pO1Pmt1P/FzzX6XQ8u5tM7230V5VLmuhFybgkUUqVGEfxPGdJSeI5GZUEcZJR9+LurGb0pchLeYbinEvKpTr5whK5pDWLqd4cdhDjTDKS6iIGv0mqpoLPZ57TXTOjPFkhIVfNFW0BKH1BMpaubERKmNhBS5rWVLKYdJAgXOjQV7a4BlozWLBv1DZ7xddrzXMSVntOgeKUCKFwTPg0pTFUhXmieaOcf8mrsuN0i4NhQNsb2aQI7aUIJbA44s0FFSZwiAlBM6gc+rmJF1rHq91SCTs/XmdvEZ+hOq8EKigX9BvY7w4tliIBP+QzkyiBg4pToCFalhSEw/IwvpnEeM1kDoog3OvTqg0E4CUiCwZyKapBBXjF4FRKkGCyIhJoUMxGmjfOywRMbqpY29JtPHx3JwrCXwtSPV2SrEjyWNvGgCasSU/TTpIKqnl/P8zuZ6E/G09wgP9xugqyt9KGqhKyAX+EOp09fg8KNJpt2PsBazKDTEuFBtoqiZ5BYN8foyBK227lHxH4NMdK43MweZj48Fh7nm91qp4eevnRko9xQPP+M0DVfGjtSeXv3Vk7Dpws9vZujn11Z+Ftm2ySmFsLOv/HAKCtsTvMuNgiTyUC7VXoDrFmaUpfI/V2XI88VXk7NVXvq1W0t20N8MNh7FH3B6UD7W2YPwlw+AceHd9IR1VH5fYv0NYHb+zV81w93NVr44R3ma63W/8C',
                    itemTemplate: function (itemData, contentElement) {
                        $("<div/>").appendTo(contentElement).dxCtrlEmailData({
                            bddCtrl: bddRef,
                            value: Me.mGetPara(itemData.key),
                            dataDefault: itemData.defaut,
                            allowSup: false,
                            tooltipModif: "Modifier le modele",
                            tooltipSupp: "Supprimer le modele",
                            tooltipNew: "Créer un nouveau modéle",
                            titlePopupEmail: itemData.title,
                            rempliTxtLib: function (contentElement, value) {
                                var txtLib = ""
                                txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>" + itemData.title + "</div>"
                                contentElement.html(txtLib)
                            },
                            onValueChanged: function (data64Signature) {
                                debugger
                                Me.mGetPara(itemData.key, data64Signature)
                            }
                        }).dxCtrlEmailData("instance")
                    }
                })
            }
        }
        lstCleModuleDefaut.forEach(function (itemData) {
            delete itemData.selected
            delete itemData.expanded
        })
        return lstCleModuleDefaut
    }

    function mGetValueDefautFromKey(key) {
        var defaut = Me.mGetLstCleModuleDefaut().filter(function (o) { return o.key == key })[0]
        if (typeof defaut == 'undefined') { defaut = null }
        else { defaut = defaut.defaut }
        return defaut
    }


    //utiliser pour les recommandations par rapport au parametre
    this.mGetLstWarning = function (dxScrollContent, mRempli) {
        var nbWarning = 0
        var nbWarningReel = 0
        if (bddRef.objCptCli.objetMetier.hasEmail() && bddRef.objCptCli.objetMetier.hasDocCpt()) {
            if (Me.mGetPara("email_adresse_suivi_envoi_auto_client").length == 0) {
                nbWarningReel += 1
                if (bddRef.utiCourantParaJson.warning.parametrage.adresse_email_pour_client_manquante != "1") {
                    nbWarning += 1
                    if (dxScrollContent != null) {
                        mRempli(function (contentElement) {
                            $("<div style='font-weight:bold;line-height:1.3;' class='dx-theme-accent-as-text-color'>L'adresse email pour recevoir une copie des mails envoyé à vos clients n'est pas défini.</div>").appendTo(contentElement)
                            $("<div style='font-size:80%;font-style:normal;line-height:1.1;opacity:0.5;'>Définissez ce paramètre pour recevoir une copie des mails automatique envoyé à vos clients (paiement CB...) en CCI.</div>").appendTo(contentElement)
                        }, "Définir email CCI suivi relation client", function () {
                            $("<div/>").appendTo("body").dxCtrlParaAppli({
                                selectedKey: "email_adresse_suivi_envoi_auto_client",
                                bddCtrl: bddRef,
                                isInPopup: true
                            })
                        }, function () {
                            bddRef.utiCourantParaJson.warning.parametrage.adresse_email_pour_client_manquante = "1"
                            bddRef.mSaveParaJsonUtilisateur();
                        }, dxScrollContent)
                    }
                }
            }
        }
        return {
            nbWarning: nbWarning,
            nbWarningReel: nbWarningReel
        }
    }

}